(function() {
  const s = document.createElement("link").relList;
  if (s && s.supports && s.supports("modulepreload")) return;
  for (const r of document.querySelectorAll('link[rel="modulepreload"]')) i(r);
  new MutationObserver(r => {
    for (const n of r)
      if (n.type === "childList")
        for (const l of n.addedNodes) l.tagName === "LINK" && l.rel === "modulepreload" && i(l)
  }).observe(document, {
    childList: !0,
    subtree: !0
  });

  function t(r) {
    const n = {};
    return r.integrity && (n.integrity = r.integrity), r.referrerPolicy && (n.referrerPolicy = r.referrerPolicy), r.crossOrigin === "use-credentials" ? n.credentials = "include" : r.crossOrigin === "anonymous" ? n.credentials = "omit" : n.credentials = "same-origin", n
  }

  function i(r) {
    if (r.ep) return;
    r.ep = !0;
    const n = t(r);
    fetch(r.href, n)
  }
})();

function ne(e) {
  return e !== null && typeof e == "object" && "constructor" in e && e.constructor === Object
}

function ie(e = {}, s = {}) {
  const t = ["__proto__", "constructor", "prototype"];
  Object.keys(s).filter(i => t.indexOf(i) < 0).forEach(i => {
    typeof e[i] > "u" ? e[i] = s[i] : ne(s[i]) && ne(e[i]) && Object.keys(s[i]).length > 0 && ie(e[i], s[i])
  })
}
const pe = {
  body: {},
  addEventListener() {},
  removeEventListener() {},
  activeElement: {
    blur() {},
    nodeName: ""
  },
  querySelector() {
    return null
  },
  querySelectorAll() {
    return []
  },
  getElementById() {
    return null
  },
  createEvent() {
    return {
      initEvent() {}
    }
  },
  createElement() {
    return {
      children: [],
      childNodes: [],
      style: {},
      setAttribute() {},
      getElementsByTagName() {
        return []
      }
    }
  },
  createElementNS() {
    return {}
  },
  importNode() {
    return null
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  }
};

function H() {
  const e = typeof document < "u" ? document : {};
  return ie(e, pe), e
}
const ye = {
  document: pe,
  navigator: {
    userAgent: ""
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  },
  history: {
    replaceState() {},
    pushState() {},
    go() {},
    back() {}
  },
  CustomEvent: function() {
    return this
  },
  addEventListener() {},
  removeEventListener() {},
  getComputedStyle() {
    return {
      getPropertyValue() {
        return ""
      }
    }
  },
  Image() {},
  Date() {},
  screen: {},
  setTimeout() {},
  clearTimeout() {},
  matchMedia() {
    return {}
  },
  requestAnimationFrame(e) {
    return typeof setTimeout > "u" ? (e(), null) : setTimeout(e, 0)
  },
  cancelAnimationFrame(e) {
    typeof setTimeout > "u" || clearTimeout(e)
  }
};

function A() {
  const e = typeof window < "u" ? window : {};
  return ie(e, ye), e
}

function xe(e = "") {
  return e.trim().split(" ").filter(s => !!s.trim())
}

function Ee(e) {
  const s = e;
  Object.keys(s).forEach(t => {
    try {
      s[t] = null
    } catch {}
    try {
      delete s[t]
    } catch {}
  })
}

function me(e, s = 0) {
  return setTimeout(e, s)
}

function j() {
  return Date.now()
}

function Me(e) {
  const s = A();
  let t;
  return s.getComputedStyle && (t = s.getComputedStyle(e, null)), !t && e.currentStyle && (t = e.currentStyle), t || (t = e.style), t
}

function Pe(e, s = "x") {
  const t = A();
  let i, r, n;
  const l = Me(e);
  return t.WebKitCSSMatrix ? (r = l.transform || l.webkitTransform, r.split(",").length > 6 && (r = r.split(", ").map(o => o.replace(",", ".")).join(", ")), n = new t.WebKitCSSMatrix(r === "none" ? "" : r)) : (n = l.MozTransform || l.OTransform || l.MsTransform || l.msTransform || l.transform || l.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,"), i = n.toString().split(",")), s === "x" && (t.WebKitCSSMatrix ? r = n.m41 : i.length === 16 ? r = parseFloat(i[12]) : r = parseFloat(i[4])), s === "y" && (t.WebKitCSSMatrix ? r = n.m42 : i.length === 16 ? r = parseFloat(i[13]) : r = parseFloat(i[5])), r || 0
}

function R(e) {
  return typeof e == "object" && e !== null && e.constructor && Object.prototype.toString.call(e).slice(8, -1) === "Object"
}

function Ce(e) {
  return typeof window < "u" && typeof window.HTMLElement < "u" ? e instanceof HTMLElement : e && (e.nodeType === 1 || e.nodeType === 11)
}

function G(...e) {
  const s = Object(e[0]),
    t = ["__proto__", "constructor", "prototype"];
  for (let i = 1; i < e.length; i += 1) {
    const r = e[i];
    if (r != null && !Ce(r)) {
      const n = Object.keys(Object(r)).filter(l => t.indexOf(l) < 0);
      for (let l = 0, o = n.length; l < o; l += 1) {
        const a = n[l],
          d = Object.getOwnPropertyDescriptor(r, a);
        d !== void 0 && d.enumerable && (R(s[a]) && R(r[a]) ? r[a].__swiper__ ? s[a] = r[a] : G(s[a], r[a]) : !R(s[a]) && R(r[a]) ? (s[a] = {}, r[a].__swiper__ ? s[a] = r[a] : G(s[a], r[a])) : s[a] = r[a])
      }
    }
  }
  return s
}

function q(e, s, t) {
  e.style.setProperty(s, t)
}

function he({
  swiper: e,
  targetPosition: s,
  side: t
}) {
  const i = A(),
    r = -e.translate;
  let n = null,
    l;
  const o = e.params.speed;
  e.wrapperEl.style.scrollSnapType = "none", i.cancelAnimationFrame(e.cssModeFrameID);
  const a = s > r ? "next" : "prev",
    d = (c, u) => a === "next" && c >= u || a === "prev" && c <= u,
    p = () => {
      l = new Date().getTime(), n === null && (n = l);
      const c = Math.max(Math.min((l - n) / o, 1), 0),
        u = .5 - Math.cos(c * Math.PI) / 2;
      let f = r + u * (s - r);
      if (d(f, s) && (f = s), e.wrapperEl.scrollTo({
          [t]: f
        }), d(f, s)) {
        e.wrapperEl.style.overflow = "hidden", e.wrapperEl.style.scrollSnapType = "", setTimeout(() => {
          e.wrapperEl.style.overflow = "", e.wrapperEl.scrollTo({
            [t]: f
          })
        }), i.cancelAnimationFrame(e.cssModeFrameID);
        return
      }
      e.cssModeFrameID = i.requestAnimationFrame(p)
    };
  p()
}

function _(e, s = "") {
  const t = A(),
    i = [...e.children];
  return t.HTMLSlotElement && e instanceof HTMLSlotElement && i.push(...e.assignedElements()), s ? i.filter(r => r.matches(s)) : i
}

function Ie(e, s) {
  const t = [s];
  for (; t.length > 0;) {
    const i = t.shift();
    if (e === i) return !0;
    t.push(...i.children, ...i.shadowRoot ? i.shadowRoot.children : [], ...i.assignedElements ? i.assignedElements() : [])
  }
}

function Le(e, s) {
  const t = A();
  let i = s.contains(e);
  return !i && t.HTMLSlotElement && s instanceof HTMLSlotElement && (i = [...s.assignedElements()].includes(e), i || (i = Ie(e, s))), i
}

function Y(e) {
  try {
    console.warn(e);
    return
  } catch {}
}

function te(e, s = []) {
  const t = document.createElement(e);
  return t.classList.add(...Array.isArray(s) ? s : xe(s)), t
}

function Oe(e, s) {
  const t = [];
  for (; e.previousElementSibling;) {
    const i = e.previousElementSibling;
    s ? i.matches(s) && t.push(i) : t.push(i), e = i
  }
  return t
}

function Ae(e, s) {
  const t = [];
  for (; e.nextElementSibling;) {
    const i = e.nextElementSibling;
    s ? i.matches(s) && t.push(i) : t.push(i), e = i
  }
  return t
}

function N(e, s) {
  return A().getComputedStyle(e, null).getPropertyValue(s)
}

function ae(e) {
  let s = e,
    t;
  if (s) {
    for (t = 0;
      (s = s.previousSibling) !== null;) s.nodeType === 1 && (t += 1);
    return t
  }
}

function ze(e, s) {
  const t = [];
  let i = e.parentElement;
  for (; i;) t.push(i), i = i.parentElement;
  return t
}

function le(e, s, t) {
  const i = A();
  return e[s === "width" ? "offsetWidth" : "offsetHeight"] + parseFloat(i.getComputedStyle(e, null).getPropertyValue(s === "width" ? "margin-right" : "margin-top")) + parseFloat(i.getComputedStyle(e, null).getPropertyValue(s === "width" ? "margin-left" : "margin-bottom"))
}
let X;

function ke() {
  const e = A(),
    s = H();
  return {
    smoothScroll: s.documentElement && s.documentElement.style && "scrollBehavior" in s.documentElement.style,
    touch: !!("ontouchstart" in e || e.DocumentTouch && s instanceof e.DocumentTouch)
  }
}

function ge() {
  return X || (X = ke()), X
}
let U;

function Ge({
  userAgent: e
} = {}) {
  const s = ge(),
    t = A(),
    i = t.navigator.platform,
    r = e || t.navigator.userAgent,
    n = {
      ios: !1,
      android: !1
    },
    l = t.screen.width,
    o = t.screen.height,
    a = r.match(/(Android);?[\s\/]+([\d.]+)?/);
  let d = r.match(/(iPad)(?!\1).*OS\s([\d_]+)/);
  const p = r.match(/(iPod)(.*OS\s([\d_]+))?/),
    c = !d && r.match(/(iPhone\sOS|iOS)\s([\d_]+)/),
    u = i === "Win32";
  let f = i === "MacIntel";
  const m = ["1024x1366", "1366x1024", "834x1194", "1194x834", "834x1112", "1112x834", "768x1024", "1024x768", "820x1180", "1180x820", "810x1080", "1080x810"];
  return !d && f && s.touch && m.indexOf(`${l}x${o}`) >= 0 && (d = r.match(/(Version)\/([\d.]+)/), d || (d = [0, 1, "13_0_0"]), f = !1), a && !u && (n.os = "android", n.android = !0), (d || c || p) && (n.os = "ios", n.ios = !0), n
}

function ve(e = {}) {
  return U || (U = Ge(e)), U
}
let K;

function De() {
  const e = A(),
    s = ve();
  let t = !1;

  function i() {
    const o = e.navigator.userAgent.toLowerCase();
    return o.indexOf("safari") >= 0 && o.indexOf("chrome") < 0 && o.indexOf("android") < 0
  }
  if (i()) {
    const o = String(e.navigator.userAgent);
    if (o.includes("Version/")) {
      const [a, d] = o.split("Version/")[1].split(" ")[0].split(".").map(p => Number(p));
      t = a < 16 || a === 16 && d < 2
    }
  }
  const r = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(e.navigator.userAgent),
    n = i(),
    l = n || r && s.ios;
  return {
    isSafari: t || n,
    needPerspectiveFix: t,
    need3dFix: l,
    isWebView: r
  }
}

function we() {
  return K || (K = De()), K
}

function Ve({
  swiper: e,
  on: s,
  emit: t
}) {
  const i = A();
  let r = null,
    n = null;
  const l = () => {
      !e || e.destroyed || !e.initialized || (t("beforeResize"), t("resize"))
    },
    o = () => {
      !e || e.destroyed || !e.initialized || (r = new ResizeObserver(p => {
        n = i.requestAnimationFrame(() => {
          const {
            width: c,
            height: u
          } = e;
          let f = c,
            m = u;
          p.forEach(({
            contentBoxSize: h,
            contentRect: b,
            target: S
          }) => {
            S && S !== e.el || (f = b ? b.width : (h[0] || h).inlineSize, m = b ? b.height : (h[0] || h).blockSize)
          }), (f !== c || m !== u) && l()
        })
      }), r.observe(e.el))
    },
    a = () => {
      n && i.cancelAnimationFrame(n), r && r.unobserve && e.el && (r.unobserve(e.el), r = null)
    },
    d = () => {
      !e || e.destroyed || !e.initialized || t("orientationchange")
    };
  s("init", () => {
    if (e.params.resizeObserver && typeof i.ResizeObserver < "u") {
      o();
      return
    }
    i.addEventListener("resize", l), i.addEventListener("orientationchange", d)
  }), s("destroy", () => {
    a(), i.removeEventListener("resize", l), i.removeEventListener("orientationchange", d)
  })
}

function _e({
  swiper: e,
  extendParams: s,
  on: t,
  emit: i
}) {
  const r = [],
    n = A(),
    l = (d, p = {}) => {
      const c = n.MutationObserver || n.WebkitMutationObserver,
        u = new c(f => {
          if (e.__preventObserver__) return;
          if (f.length === 1) {
            i("observerUpdate", f[0]);
            return
          }
          const m = function() {
            i("observerUpdate", f[0])
          };
          n.requestAnimationFrame ? n.requestAnimationFrame(m) : n.setTimeout(m, 0)
        });
      u.observe(d, {
        attributes: typeof p.attributes > "u" ? !0 : p.attributes,
        childList: e.isElement || (typeof p.childList > "u" ? !0 : p).childList,
        characterData: typeof p.characterData > "u" ? !0 : p.characterData
      }), r.push(u)
    },
    o = () => {
      if (e.params.observer) {
        if (e.params.observeParents) {
          const d = ze(e.hostEl);
          for (let p = 0; p < d.length; p += 1) l(d[p])
        }
        l(e.hostEl, {
          childList: e.params.observeSlideChildren
        }), l(e.wrapperEl, {
          attributes: !1
        })
      }
    },
    a = () => {
      r.forEach(d => {
        d.disconnect()
      }), r.splice(0, r.length)
    };
  s({
    observer: !1,
    observeParents: !1,
    observeSlideChildren: !1
  }), t("init", o), t("destroy", a)
}
var Be = {
  on(e, s, t) {
    const i = this;
    if (!i.eventsListeners || i.destroyed || typeof s != "function") return i;
    const r = t ? "unshift" : "push";
    return e.split(" ").forEach(n => {
      i.eventsListeners[n] || (i.eventsListeners[n] = []), i.eventsListeners[n][r](s)
    }), i
  },
  once(e, s, t) {
    const i = this;
    if (!i.eventsListeners || i.destroyed || typeof s != "function") return i;

    function r(...n) {
      i.off(e, r), r.__emitterProxy && delete r.__emitterProxy, s.apply(i, n)
    }
    return r.__emitterProxy = s, i.on(e, r, t)
  },
  onAny(e, s) {
    const t = this;
    if (!t.eventsListeners || t.destroyed || typeof e != "function") return t;
    const i = s ? "unshift" : "push";
    return t.eventsAnyListeners.indexOf(e) < 0 && t.eventsAnyListeners[i](e), t
  },
  offAny(e) {
    const s = this;
    if (!s.eventsListeners || s.destroyed || !s.eventsAnyListeners) return s;
    const t = s.eventsAnyListeners.indexOf(e);
    return t >= 0 && s.eventsAnyListeners.splice(t, 1), s
  },
  off(e, s) {
    const t = this;
    return !t.eventsListeners || t.destroyed || !t.eventsListeners || e.split(" ").forEach(i => {
      typeof s > "u" ? t.eventsListeners[i] = [] : t.eventsListeners[i] && t.eventsListeners[i].forEach((r, n) => {
        (r === s || r.__emitterProxy && r.__emitterProxy === s) && t.eventsListeners[i].splice(n, 1)
      })
    }), t
  },
  emit(...e) {
    const s = this;
    if (!s.eventsListeners || s.destroyed || !s.eventsListeners) return s;
    let t, i, r;
    return typeof e[0] == "string" || Array.isArray(e[0]) ? (t = e[0], i = e.slice(1, e.length), r = s) : (t = e[0].events, i = e[0].data, r = e[0].context || s), i.unshift(r), (Array.isArray(t) ? t : t.split(" ")).forEach(l => {
      s.eventsAnyListeners && s.eventsAnyListeners.length && s.eventsAnyListeners.forEach(o => {
        o.apply(r, [l, ...i])
      }), s.eventsListeners && s.eventsListeners[l] && s.eventsListeners[l].forEach(o => {
        o.apply(r, i)
      })
    }), s
  }
};

function Fe() {
  const e = this;
  let s, t;
  const i = e.el;
  typeof e.params.width < "u" && e.params.width !== null ? s = e.params.width : s = i.clientWidth, typeof e.params.height < "u" && e.params.height !== null ? t = e.params.height : t = i.clientHeight, !(s === 0 && e.isHorizontal() || t === 0 && e.isVertical()) && (s = s - parseInt(N(i, "padding-left") || 0, 10) - parseInt(N(i, "padding-right") || 0, 10), t = t - parseInt(N(i, "padding-top") || 0, 10) - parseInt(N(i, "padding-bottom") || 0, 10), Number.isNaN(s) && (s = 0), Number.isNaN(t) && (t = 0), Object.assign(e, {
    width: s,
    height: t,
    size: e.isHorizontal() ? s : t
  }))
}

function Ne() {
  const e = this;

  function s(x, T) {
    return parseFloat(x.getPropertyValue(e.getDirectionLabel(T)) || 0)
  }
  const t = e.params,
    {
      wrapperEl: i,
      slidesEl: r,
      rtlTranslate: n,
      wrongRTL: l
    } = e,
    o = e.virtual && t.virtual.enabled,
    a = o ? e.virtual.slides.length : e.slides.length,
    d = _(r, `.${e.params.slideClass}, swiper-slide`),
    p = o ? e.virtual.slides.length : d.length;
  let c = [];
  const u = [],
    f = [];
  let m = t.slidesOffsetBefore;
  typeof m == "function" && (m = t.slidesOffsetBefore.call(e));
  let h = t.slidesOffsetAfter;
  typeof h == "function" && (h = t.slidesOffsetAfter.call(e));
  const b = e.snapGrid.length,
    S = e.slidesGrid.length,
    g = e.size - m - h;
  let v = t.spaceBetween,
    E = -m,
    w = 0,
    I = 0;
  if (typeof g > "u") return;
  typeof v == "string" && v.indexOf("%") >= 0 ? v = parseFloat(v.replace("%", "")) / 100 * g : typeof v == "string" && (v = parseFloat(v)), e.virtualSize = -v - m - h, d.forEach(x => {
    n ? x.style.marginLeft = "" : x.style.marginRight = "", x.style.marginBottom = "", x.style.marginTop = ""
  }), t.centeredSlides && t.cssMode && (q(i, "--swiper-centered-offset-before", ""), q(i, "--swiper-centered-offset-after", ""));
  const M = t.grid && t.grid.rows > 1 && e.grid;
  M ? e.grid.initSlides(d) : e.grid && e.grid.unsetSlides();
  let y;
  const L = t.slidesPerView === "auto" && t.breakpoints && Object.keys(t.breakpoints).filter(x => typeof t.breakpoints[x].slidesPerView < "u").length > 0;
  for (let x = 0; x < p; x += 1) {
    y = 0;
    const T = d[x];
    if (!(T && (M && e.grid.updateSlide(x, T, d), N(T, "display") === "none"))) {
      if (o && t.slidesPerView === "auto") t.virtual.slidesPerViewAutoSlideSize && (y = t.virtual.slidesPerViewAutoSlideSize), y && T && (t.roundLengths && (y = Math.floor(y)), T.style[e.getDirectionLabel("width")] = `${y}px`);
      else if (t.slidesPerView === "auto") {
        L && (T.style[e.getDirectionLabel("width")] = "");
        const C = getComputedStyle(T),
          z = T.style.transform,
          V = T.style.webkitTransform;
        if (z && (T.style.transform = "none"), V && (T.style.webkitTransform = "none"), t.roundLengths) y = e.isHorizontal() ? le(T, "width") : le(T, "height");
        else {
          const B = s(C, "width"),
            re = s(C, "padding-left"),
            $ = s(C, "padding-right"),
            P = s(C, "margin-left"),
            O = s(C, "margin-right"),
            k = C.getPropertyValue("box-sizing");
          if (k && k === "border-box") y = B + P + O;
          else {
            const {
              clientWidth: F,
              offsetWidth: be
            } = T;
            y = B + re + $ + P + O + (be - F)
          }
        }
        z && (T.style.transform = z), V && (T.style.webkitTransform = V), t.roundLengths && (y = Math.floor(y))
      } else y = (g - (t.slidesPerView - 1) * v) / t.slidesPerView, t.roundLengths && (y = Math.floor(y)), T && (T.style[e.getDirectionLabel("width")] = `${y}px`);
      T && (T.swiperSlideSize = y), f.push(y), t.centeredSlides ? (E = E + y / 2 + w / 2 + v, w === 0 && x !== 0 && (E = E - g / 2 - v), x === 0 && (E = E - g / 2 - v), Math.abs(E) < 1 / 1e3 && (E = 0), t.roundLengths && (E = Math.floor(E)), I % t.slidesPerGroup === 0 && c.push(E), u.push(E)) : (t.roundLengths && (E = Math.floor(E)), (I - Math.min(e.params.slidesPerGroupSkip, I)) % e.params.slidesPerGroup === 0 && c.push(E), u.push(E), E = E + y + v), e.virtualSize += y + v, w = y, I += 1
    }
  }
  if (e.virtualSize = Math.max(e.virtualSize, g) + h, n && l && (t.effect === "slide" || t.effect === "coverflow") && (i.style.width = `${e.virtualSize + v}px`), t.setWrapperSize && (i.style[e.getDirectionLabel("width")] = `${e.virtualSize + v}px`), M && e.grid.updateWrapperSize(y, c), !t.centeredSlides) {
    const x = [];
    for (let T = 0; T < c.length; T += 1) {
      let C = c[T];
      t.roundLengths && (C = Math.floor(C)), c[T] <= e.virtualSize - g && x.push(C)
    }
    c = x, Math.floor(e.virtualSize - g) - Math.floor(c[c.length - 1]) > 1 && c.push(e.virtualSize - g)
  }
  if (o && t.loop) {
    const x = f[0] + v;
    if (t.slidesPerGroup > 1) {
      const T = Math.ceil((e.virtual.slidesBefore + e.virtual.slidesAfter) / t.slidesPerGroup),
        C = x * t.slidesPerGroup;
      for (let z = 0; z < T; z += 1) c.push(c[c.length - 1] + C)
    }
    for (let T = 0; T < e.virtual.slidesBefore + e.virtual.slidesAfter; T += 1) t.slidesPerGroup === 1 && c.push(c[c.length - 1] + x), u.push(u[u.length - 1] + x), e.virtualSize += x
  }
  if (c.length === 0 && (c = [0]), v !== 0) {
    const x = e.isHorizontal() && n ? "marginLeft" : e.getDirectionLabel("marginRight");
    d.filter((T, C) => !t.cssMode || t.loop ? !0 : C !== d.length - 1).forEach(T => {
      T.style[x] = `${v}px`
    })
  }
  if (t.centeredSlides && t.centeredSlidesBounds) {
    let x = 0;
    f.forEach(C => {
      x += C + (v || 0)
    }), x -= v;
    const T = x > g ? x - g : 0;
    c = c.map(C => C <= 0 ? -m : C > T ? T + h : C)
  }
  if (t.centerInsufficientSlides) {
    let x = 0;
    f.forEach(C => {
      x += C + (v || 0)
    }), x -= v;
    const T = (m || 0) + (h || 0);
    if (x + T < g) {
      const C = (g - x - T) / 2;
      c.forEach((z, V) => {
        c[V] = z - C
      }), u.forEach((z, V) => {
        u[V] = z + C
      })
    }
  }
  if (Object.assign(e, {
      slides: d,
      snapGrid: c,
      slidesGrid: u,
      slidesSizesGrid: f
    }), t.centeredSlides && t.cssMode && !t.centeredSlidesBounds) {
    q(i, "--swiper-centered-offset-before", `${-c[0]}px`), q(i, "--swiper-centered-offset-after", `${e.size / 2 - f[f.length - 1] / 2}px`);
    const x = -e.snapGrid[0],
      T = -e.slidesGrid[0];
    e.snapGrid = e.snapGrid.map(C => C + x), e.slidesGrid = e.slidesGrid.map(C => C + T)
  }
  if (p !== a && e.emit("slidesLengthChange"), c.length !== b && (e.params.watchOverflow && e.checkOverflow(), e.emit("snapGridLengthChange")), u.length !== S && e.emit("slidesGridLengthChange"), t.watchSlidesProgress && e.updateSlidesOffset(), e.emit("slidesUpdated"), !o && !t.cssMode && (t.effect === "slide" || t.effect === "fade")) {
    const x = `${t.containerModifierClass}backface-hidden`,
      T = e.el.classList.contains(x);
    p <= t.maxBackfaceHiddenSlides ? T || e.el.classList.add(x) : T && e.el.classList.remove(x)
  }
}

function $e(e) {
  const s = this,
    t = [],
    i = s.virtual && s.params.virtual.enabled;
  let r = 0,
    n;
  typeof e == "number" ? s.setTransition(e) : e === !0 && s.setTransition(s.params.speed);
  const l = o => i ? s.slides[s.getSlideIndexByData(o)] : s.slides[o];
  if (s.params.slidesPerView !== "auto" && s.params.slidesPerView > 1)
    if (s.params.centeredSlides)(s.visibleSlides || []).forEach(o => {
      t.push(o)
    });
    else
      for (n = 0; n < Math.ceil(s.params.slidesPerView); n += 1) {
        const o = s.activeIndex + n;
        if (o > s.slides.length && !i) break;
        t.push(l(o))
      } else t.push(l(s.activeIndex));
  for (n = 0; n < t.length; n += 1)
    if (typeof t[n] < "u") {
      const o = t[n].offsetHeight;
      r = o > r ? o : r
    }(r || r === 0) && (s.wrapperEl.style.height = `${r}px`)
}

function He() {
  const e = this,
    s = e.slides,
    t = e.isElement ? e.isHorizontal() ? e.wrapperEl.offsetLeft : e.wrapperEl.offsetTop : 0;
  for (let i = 0; i < s.length; i += 1) s[i].swiperSlideOffset = (e.isHorizontal() ? s[i].offsetLeft : s[i].offsetTop) - t - e.cssOverflowAdjustment()
}
const oe = (e, s, t) => {
  s && !e.classList.contains(t) ? e.classList.add(t) : !s && e.classList.contains(t) && e.classList.remove(t)
};

function Re(e = this && this.translate || 0) {
  const s = this,
    t = s.params,
    {
      slides: i,
      rtlTranslate: r,
      snapGrid: n
    } = s;
  if (i.length === 0) return;
  typeof i[0].swiperSlideOffset > "u" && s.updateSlidesOffset();
  let l = -e;
  r && (l = e), s.visibleSlidesIndexes = [], s.visibleSlides = [];
  let o = t.spaceBetween;
  typeof o == "string" && o.indexOf("%") >= 0 ? o = parseFloat(o.replace("%", "")) / 100 * s.size : typeof o == "string" && (o = parseFloat(o));
  for (let a = 0; a < i.length; a += 1) {
    const d = i[a];
    let p = d.swiperSlideOffset;
    t.cssMode && t.centeredSlides && (p -= i[0].swiperSlideOffset);
    const c = (l + (t.centeredSlides ? s.minTranslate() : 0) - p) / (d.swiperSlideSize + o),
      u = (l - n[0] + (t.centeredSlides ? s.minTranslate() : 0) - p) / (d.swiperSlideSize + o),
      f = -(l - p),
      m = f + s.slidesSizesGrid[a],
      h = f >= 0 && f <= s.size - s.slidesSizesGrid[a],
      b = f >= 0 && f < s.size - 1 || m > 1 && m <= s.size || f <= 0 && m >= s.size;
    b && (s.visibleSlides.push(d), s.visibleSlidesIndexes.push(a)), oe(d, b, t.slideVisibleClass), oe(d, h, t.slideFullyVisibleClass), d.progress = r ? -c : c, d.originalProgress = r ? -u : u
  }
}

function qe(e) {
  const s = this;
  if (typeof e > "u") {
    const p = s.rtlTranslate ? -1 : 1;
    e = s && s.translate && s.translate * p || 0
  }
  const t = s.params,
    i = s.maxTranslate() - s.minTranslate();
  let {
    progress: r,
    isBeginning: n,
    isEnd: l,
    progressLoop: o
  } = s;
  const a = n,
    d = l;
  if (i === 0) r = 0, n = !0, l = !0;
  else {
    r = (e - s.minTranslate()) / i;
    const p = Math.abs(e - s.minTranslate()) < 1,
      c = Math.abs(e - s.maxTranslate()) < 1;
    n = p || r <= 0, l = c || r >= 1, p && (r = 0), c && (r = 1)
  }
  if (t.loop) {
    const p = s.getSlideIndexByData(0),
      c = s.getSlideIndexByData(s.slides.length - 1),
      u = s.slidesGrid[p],
      f = s.slidesGrid[c],
      m = s.slidesGrid[s.slidesGrid.length - 1],
      h = Math.abs(e);
    h >= u ? o = (h - u) / m : o = (h + m - f) / m, o > 1 && (o -= 1)
  }
  Object.assign(s, {
    progress: r,
    progressLoop: o,
    isBeginning: n,
    isEnd: l
  }), (t.watchSlidesProgress || t.centeredSlides && t.autoHeight) && s.updateSlidesProgress(e), n && !a && s.emit("reachBeginning toEdge"), l && !d && s.emit("reachEnd toEdge"), (a && !n || d && !l) && s.emit("fromEdge"), s.emit("progress", r)
}
const Q = (e, s, t) => {
  s && !e.classList.contains(t) ? e.classList.add(t) : !s && e.classList.contains(t) && e.classList.remove(t)
};

function We() {
  const e = this,
    {
      slides: s,
      params: t,
      slidesEl: i,
      activeIndex: r
    } = e,
    n = e.virtual && t.virtual.enabled,
    l = e.grid && t.grid && t.grid.rows > 1,
    o = c => _(i, `.${t.slideClass}${c}, swiper-slide${c}`)[0];
  let a, d, p;
  if (n)
    if (t.loop) {
      let c = r - e.virtual.slidesBefore;
      c < 0 && (c = e.virtual.slides.length + c), c >= e.virtual.slides.length && (c -= e.virtual.slides.length), a = o(`[data-swiper-slide-index="${c}"]`)
    } else a = o(`[data-swiper-slide-index="${r}"]`);
  else l ? (a = s.find(c => c.column === r), p = s.find(c => c.column === r + 1), d = s.find(c => c.column === r - 1)) : a = s[r];
  a && (l || (p = Ae(a, `.${t.slideClass}, swiper-slide`)[0], t.loop && !p && (p = s[0]), d = Oe(a, `.${t.slideClass}, swiper-slide`)[0], t.loop && !d === 0 && (d = s[s.length - 1]))), s.forEach(c => {
    Q(c, c === a, t.slideActiveClass), Q(c, c === p, t.slideNextClass), Q(c, c === d, t.slidePrevClass)
  }), e.emitSlidesClasses()
}
const W = (e, s) => {
    if (!e || e.destroyed || !e.params) return;
    const t = () => e.isElement ? "swiper-slide" : `.${e.params.slideClass}`,
      i = s.closest(t());
    if (i) {
      let r = i.querySelector(`.${e.params.lazyPreloaderClass}`);
      !r && e.isElement && (i.shadowRoot ? r = i.shadowRoot.querySelector(`.${e.params.lazyPreloaderClass}`) : requestAnimationFrame(() => {
        i.shadowRoot && (r = i.shadowRoot.querySelector(`.${e.params.lazyPreloaderClass}`), r && r.remove())
      })), r && r.remove()
    }
  },
  J = (e, s) => {
    if (!e.slides[s]) return;
    const t = e.slides[s].querySelector('[loading="lazy"]');
    t && t.removeAttribute("loading")
  },
  se = e => {
    if (!e || e.destroyed || !e.params) return;
    let s = e.params.lazyPreloadPrevNext;
    const t = e.slides.length;
    if (!t || !s || s < 0) return;
    s = Math.min(s, t);
    const i = e.params.slidesPerView === "auto" ? e.slidesPerViewDynamic() : Math.ceil(e.params.slidesPerView),
      r = e.activeIndex;
    if (e.params.grid && e.params.grid.rows > 1) {
      const l = r,
        o = [l - s];
      o.push(...Array.from({
        length: s
      }).map((a, d) => l + i + d)), e.slides.forEach((a, d) => {
        o.includes(a.column) && J(e, d)
      });
      return
    }
    const n = r + i - 1;
    if (e.params.rewind || e.params.loop)
      for (let l = r - s; l <= n + s; l += 1) {
        const o = (l % t + t) % t;
        (o < r || o > n) && J(e, o)
      } else
        for (let l = Math.max(r - s, 0); l <= Math.min(n + s, t - 1); l += 1) l !== r && (l > n || l < r) && J(e, l)
  };

function je(e) {
  const {
    slidesGrid: s,
    params: t
  } = e, i = e.rtlTranslate ? e.translate : -e.translate;
  let r;
  for (let n = 0; n < s.length; n += 1) typeof s[n + 1] < "u" ? i >= s[n] && i < s[n + 1] - (s[n + 1] - s[n]) / 2 ? r = n : i >= s[n] && i < s[n + 1] && (r = n + 1) : i >= s[n] && (r = n);
  return t.normalizeSlideIndex && (r < 0 || typeof r > "u") && (r = 0), r
}

function Ye(e) {
  const s = this,
    t = s.rtlTranslate ? s.translate : -s.translate,
    {
      snapGrid: i,
      params: r,
      activeIndex: n,
      realIndex: l,
      snapIndex: o
    } = s;
  let a = e,
    d;
  const p = f => {
    let m = f - s.virtual.slidesBefore;
    return m < 0 && (m = s.virtual.slides.length + m), m >= s.virtual.slides.length && (m -= s.virtual.slides.length), m
  };
  if (typeof a > "u" && (a = je(s)), i.indexOf(t) >= 0) d = i.indexOf(t);
  else {
    const f = Math.min(r.slidesPerGroupSkip, a);
    d = f + Math.floor((a - f) / r.slidesPerGroup)
  }
  if (d >= i.length && (d = i.length - 1), a === n && !s.params.loop) {
    d !== o && (s.snapIndex = d, s.emit("snapIndexChange"));
    return
  }
  if (a === n && s.params.loop && s.virtual && s.params.virtual.enabled) {
    s.realIndex = p(a);
    return
  }
  const c = s.grid && r.grid && r.grid.rows > 1;
  let u;
  if (s.virtual && r.virtual.enabled && r.loop) u = p(a);
  else if (c) {
    const f = s.slides.find(h => h.column === a);
    let m = parseInt(f.getAttribute("data-swiper-slide-index"), 10);
    Number.isNaN(m) && (m = Math.max(s.slides.indexOf(f), 0)), u = Math.floor(m / r.grid.rows)
  } else if (s.slides[a]) {
    const f = s.slides[a].getAttribute("data-swiper-slide-index");
    f ? u = parseInt(f, 10) : u = a
  } else u = a;
  Object.assign(s, {
    previousSnapIndex: o,
    snapIndex: d,
    previousRealIndex: l,
    realIndex: u,
    previousIndex: n,
    activeIndex: a
  }), s.initialized && se(s), s.emit("activeIndexChange"), s.emit("snapIndexChange"), (s.initialized || s.params.runCallbacksOnInit) && (l !== u && s.emit("realIndexChange"), s.emit("slideChange"))
}

function Xe(e, s) {
  const t = this,
    i = t.params;
  let r = e.closest(`.${i.slideClass}, swiper-slide`);
  !r && t.isElement && s && s.length > 1 && s.includes(e) && [...s.slice(s.indexOf(e) + 1, s.length)].forEach(o => {
    !r && o.matches && o.matches(`.${i.slideClass}, swiper-slide`) && (r = o)
  });
  let n = !1,
    l;
  if (r) {
    for (let o = 0; o < t.slides.length; o += 1)
      if (t.slides[o] === r) {
        n = !0, l = o;
        break
      }
  }
  if (r && n) t.clickedSlide = r, t.virtual && t.params.virtual.enabled ? t.clickedIndex = parseInt(r.getAttribute("data-swiper-slide-index"), 10) : t.clickedIndex = l;
  else {
    t.clickedSlide = void 0, t.clickedIndex = void 0;
    return
  }
  i.slideToClickedSlide && t.clickedIndex !== void 0 && t.clickedIndex !== t.activeIndex && t.slideToClickedSlide()
}
var Ue = {
  updateSize: Fe,
  updateSlides: Ne,
  updateAutoHeight: $e,
  updateSlidesOffset: He,
  updateSlidesProgress: Re,
  updateProgress: qe,
  updateSlidesClasses: We,
  updateActiveIndex: Ye,
  updateClickedSlide: Xe
};

function Ke(e = this.isHorizontal() ? "x" : "y") {
  const s = this,
    {
      params: t,
      rtlTranslate: i,
      translate: r,
      wrapperEl: n
    } = s;
  if (t.virtualTranslate) return i ? -r : r;
  if (t.cssMode) return r;
  let l = Pe(n, e);
  return l += s.cssOverflowAdjustment(), i && (l = -l), l || 0
}

function Qe(e, s) {
  const t = this,
    {
      rtlTranslate: i,
      params: r,
      wrapperEl: n,
      progress: l
    } = t;
  let o = 0,
    a = 0;
  const d = 0;
  t.isHorizontal() ? o = i ? -e : e : a = e, r.roundLengths && (o = Math.floor(o), a = Math.floor(a)), t.previousTranslate = t.translate, t.translate = t.isHorizontal() ? o : a, r.cssMode ? n[t.isHorizontal() ? "scrollLeft" : "scrollTop"] = t.isHorizontal() ? -o : -a : r.virtualTranslate || (t.isHorizontal() ? o -= t.cssOverflowAdjustment() : a -= t.cssOverflowAdjustment(), n.style.transform = `translate3d(${o}px, ${a}px, ${d}px)`);
  let p;
  const c = t.maxTranslate() - t.minTranslate();
  c === 0 ? p = 0 : p = (e - t.minTranslate()) / c, p !== l && t.updateProgress(e), t.emit("setTranslate", t.translate, s)
}

function Je() {
  return -this.snapGrid[0]
}

function Ze() {
  return -this.snapGrid[this.snapGrid.length - 1]
}

function et(e = 0, s = this.params.speed, t = !0, i = !0, r) {
  const n = this,
    {
      params: l,
      wrapperEl: o
    } = n;
  if (n.animating && l.preventInteractionOnTransition) return !1;
  const a = n.minTranslate(),
    d = n.maxTranslate();
  let p;
  if (i && e > a ? p = a : i && e < d ? p = d : p = e, n.updateProgress(p), l.cssMode) {
    const c = n.isHorizontal();
    if (s === 0) o[c ? "scrollLeft" : "scrollTop"] = -p;
    else {
      if (!n.support.smoothScroll) return he({
        swiper: n,
        targetPosition: -p,
        side: c ? "left" : "top"
      }), !0;
      o.scrollTo({
        [c ? "left" : "top"]: -p,
        behavior: "smooth"
      })
    }
    return !0
  }
  return s === 0 ? (n.setTransition(0), n.setTranslate(p), t && (n.emit("beforeTransitionStart", s, r), n.emit("transitionEnd"))) : (n.setTransition(s), n.setTranslate(p), t && (n.emit("beforeTransitionStart", s, r), n.emit("transitionStart")), n.animating || (n.animating = !0, n.onTranslateToWrapperTransitionEnd || (n.onTranslateToWrapperTransitionEnd = function(u) {
    !n || n.destroyed || u.target === this && (n.wrapperEl.removeEventListener("transitionend", n.onTranslateToWrapperTransitionEnd), n.onTranslateToWrapperTransitionEnd = null, delete n.onTranslateToWrapperTransitionEnd, n.animating = !1, t && n.emit("transitionEnd"))
  }), n.wrapperEl.addEventListener("transitionend", n.onTranslateToWrapperTransitionEnd))), !0
}
var tt = {
  getTranslate: Ke,
  setTranslate: Qe,
  minTranslate: Je,
  maxTranslate: Ze,
  translateTo: et
};

function st(e, s) {
  const t = this;
  t.params.cssMode || (t.wrapperEl.style.transitionDuration = `${e}ms`, t.wrapperEl.style.transitionDelay = e === 0 ? "0ms" : ""), t.emit("setTransition", e, s)
}

function Se({
  swiper: e,
  runCallbacks: s,
  direction: t,
  step: i
}) {
  const {
    activeIndex: r,
    previousIndex: n
  } = e;
  let l = t;
  l || (r > n ? l = "next" : r < n ? l = "prev" : l = "reset"), e.emit(`transition${i}`), s && l === "reset" ? e.emit(`slideResetTransition${i}`) : s && r !== n && (e.emit(`slideChangeTransition${i}`), l === "next" ? e.emit(`slideNextTransition${i}`) : e.emit(`slidePrevTransition${i}`))
}

function it(e = !0, s) {
  const t = this,
    {
      params: i
    } = t;
  i.cssMode || (i.autoHeight && t.updateAutoHeight(), Se({
    swiper: t,
    runCallbacks: e,
    direction: s,
    step: "Start"
  }))
}

function rt(e = !0, s) {
  const t = this,
    {
      params: i
    } = t;
  t.animating = !1, !i.cssMode && (t.setTransition(0), Se({
    swiper: t,
    runCallbacks: e,
    direction: s,
    step: "End"
  }))
}
var nt = {
  setTransition: st,
  transitionStart: it,
  transitionEnd: rt
};

function at(e = 0, s, t = !0, i, r) {
  typeof e == "string" && (e = parseInt(e, 10));
  const n = this;
  let l = e;
  l < 0 && (l = 0);
  const {
    params: o,
    snapGrid: a,
    slidesGrid: d,
    previousIndex: p,
    activeIndex: c,
    rtlTranslate: u,
    wrapperEl: f,
    enabled: m
  } = n;
  if (!m && !i && !r || n.destroyed || n.animating && o.preventInteractionOnTransition) return !1;
  typeof s > "u" && (s = n.params.speed);
  const h = Math.min(n.params.slidesPerGroupSkip, l);
  let b = h + Math.floor((l - h) / n.params.slidesPerGroup);
  b >= a.length && (b = a.length - 1);
  const S = -a[b];
  if (o.normalizeSlideIndex)
    for (let M = 0; M < d.length; M += 1) {
      const y = -Math.floor(S * 100),
        L = Math.floor(d[M] * 100),
        x = Math.floor(d[M + 1] * 100);
      typeof d[M + 1] < "u" ? y >= L && y < x - (x - L) / 2 ? l = M : y >= L && y < x && (l = M + 1) : y >= L && (l = M)
    }
  if (n.initialized && l !== c && (!n.allowSlideNext && (u ? S > n.translate && S > n.minTranslate() : S < n.translate && S < n.minTranslate()) || !n.allowSlidePrev && S > n.translate && S > n.maxTranslate() && (c || 0) !== l)) return !1;
  l !== (p || 0) && t && n.emit("beforeSlideChangeStart"), n.updateProgress(S);
  let g;
  l > c ? g = "next" : l < c ? g = "prev" : g = "reset";
  const v = n.virtual && n.params.virtual.enabled;
  if (!(v && r) && (u && -S === n.translate || !u && S === n.translate)) return n.updateActiveIndex(l), o.autoHeight && n.updateAutoHeight(), n.updateSlidesClasses(), o.effect !== "slide" && n.setTranslate(S), g !== "reset" && (n.transitionStart(t, g), n.transitionEnd(t, g)), !1;
  if (o.cssMode) {
    const M = n.isHorizontal(),
      y = u ? S : -S;
    if (s === 0) v && (n.wrapperEl.style.scrollSnapType = "none", n._immediateVirtual = !0), v && !n._cssModeVirtualInitialSet && n.params.initialSlide > 0 ? (n._cssModeVirtualInitialSet = !0, requestAnimationFrame(() => {
      f[M ? "scrollLeft" : "scrollTop"] = y
    })) : f[M ? "scrollLeft" : "scrollTop"] = y, v && requestAnimationFrame(() => {
      n.wrapperEl.style.scrollSnapType = "", n._immediateVirtual = !1
    });
    else {
      if (!n.support.smoothScroll) return he({
        swiper: n,
        targetPosition: y,
        side: M ? "left" : "top"
      }), !0;
      f.scrollTo({
        [M ? "left" : "top"]: y,
        behavior: "smooth"
      })
    }
    return !0
  }
  const I = we().isSafari;
  return v && !r && I && n.isElement && n.virtual.update(!1, !1, l), n.setTransition(s), n.setTranslate(S), n.updateActiveIndex(l), n.updateSlidesClasses(), n.emit("beforeTransitionStart", s, i), n.transitionStart(t, g), s === 0 ? n.transitionEnd(t, g) : n.animating || (n.animating = !0, n.onSlideToWrapperTransitionEnd || (n.onSlideToWrapperTransitionEnd = function(y) {
    !n || n.destroyed || y.target === this && (n.wrapperEl.removeEventListener("transitionend", n.onSlideToWrapperTransitionEnd), n.onSlideToWrapperTransitionEnd = null, delete n.onSlideToWrapperTransitionEnd, n.transitionEnd(t, g))
  }), n.wrapperEl.addEventListener("transitionend", n.onSlideToWrapperTransitionEnd)), !0
}

function lt(e = 0, s, t = !0, i) {
  typeof e == "string" && (e = parseInt(e, 10));
  const r = this;
  if (r.destroyed) return;
  typeof s > "u" && (s = r.params.speed);
  const n = r.grid && r.params.grid && r.params.grid.rows > 1;
  let l = e;
  if (r.params.loop)
    if (r.virtual && r.params.virtual.enabled) l = l + r.virtual.slidesBefore;
    else {
      let o;
      if (n) {
        const h = l * r.params.grid.rows;
        o = r.slides.find(b => b.getAttribute("data-swiper-slide-index") * 1 === h).column
      } else o = r.getSlideIndexByData(l);
      const a = n ? Math.ceil(r.slides.length / r.params.grid.rows) : r.slides.length,
        {
          centeredSlides: d,
          slidesOffsetBefore: p,
          slidesOffsetAfter: c
        } = r.params,
        u = d || !!p || !!c;
      let f = r.params.slidesPerView;
      f === "auto" ? f = r.slidesPerViewDynamic() : (f = Math.ceil(parseFloat(r.params.slidesPerView, 10)), u && f % 2 === 0 && (f = f + 1));
      let m = a - o < f;
      if (u && (m = m || o < Math.ceil(f / 2)), i && u && r.params.slidesPerView !== "auto" && !n && (m = !1), m) {
        const h = u ? o < r.activeIndex ? "prev" : "next" : o - r.activeIndex - 1 < r.params.slidesPerView ? "next" : "prev";
        r.loopFix({
          direction: h,
          slideTo: !0,
          activeSlideIndex: h === "next" ? o + 1 : o - a + 1,
          slideRealIndex: h === "next" ? r.realIndex : void 0
        })
      }
      if (n) {
        const h = l * r.params.grid.rows;
        l = r.slides.find(b => b.getAttribute("data-swiper-slide-index") * 1 === h).column
      } else l = r.getSlideIndexByData(l)
    } return requestAnimationFrame(() => {
    r.slideTo(l, s, t, i)
  }), r
}

function ot(e, s = !0, t) {
  const i = this,
    {
      enabled: r,
      params: n,
      animating: l
    } = i;
  if (!r || i.destroyed) return i;
  typeof e > "u" && (e = i.params.speed);
  let o = n.slidesPerGroup;
  n.slidesPerView === "auto" && n.slidesPerGroup === 1 && n.slidesPerGroupAuto && (o = Math.max(i.slidesPerViewDynamic("current", !0), 1));
  const a = i.activeIndex < n.slidesPerGroupSkip ? 1 : o,
    d = i.virtual && n.virtual.enabled;
  if (n.loop) {
    if (l && !d && n.loopPreventsSliding) return !1;
    if (i.loopFix({
        direction: "next"
      }), i._clientLeft = i.wrapperEl.clientLeft, i.activeIndex === i.slides.length - 1 && n.cssMode) return requestAnimationFrame(() => {
      i.slideTo(i.activeIndex + a, e, s, t)
    }), !0
  }
  return n.rewind && i.isEnd ? i.slideTo(0, e, s, t) : i.slideTo(i.activeIndex + a, e, s, t)
}

function dt(e, s = !0, t) {
  const i = this,
    {
      params: r,
      snapGrid: n,
      slidesGrid: l,
      rtlTranslate: o,
      enabled: a,
      animating: d
    } = i;
  if (!a || i.destroyed) return i;
  typeof e > "u" && (e = i.params.speed);
  const p = i.virtual && r.virtual.enabled;
  if (r.loop) {
    if (d && !p && r.loopPreventsSliding) return !1;
    i.loopFix({
      direction: "prev"
    }), i._clientLeft = i.wrapperEl.clientLeft
  }
  const c = o ? i.translate : -i.translate;

  function u(g) {
    return g < 0 ? -Math.floor(Math.abs(g)) : Math.floor(g)
  }
  const f = u(c),
    m = n.map(g => u(g)),
    h = r.freeMode && r.freeMode.enabled;
  let b = n[m.indexOf(f) - 1];
  if (typeof b > "u" && (r.cssMode || h)) {
    let g;
    n.forEach((v, E) => {
      f >= v && (g = E)
    }), typeof g < "u" && (b = h ? n[g] : n[g > 0 ? g - 1 : g])
  }
  let S = 0;
  if (typeof b < "u" && (S = l.indexOf(b), S < 0 && (S = i.activeIndex - 1), r.slidesPerView === "auto" && r.slidesPerGroup === 1 && r.slidesPerGroupAuto && (S = S - i.slidesPerViewDynamic("previous", !0) + 1, S = Math.max(S, 0))), r.rewind && i.isBeginning) {
    const g = i.params.virtual && i.params.virtual.enabled && i.virtual ? i.virtual.slides.length - 1 : i.slides.length - 1;
    return i.slideTo(g, e, s, t)
  } else if (r.loop && i.activeIndex === 0 && r.cssMode) return requestAnimationFrame(() => {
    i.slideTo(S, e, s, t)
  }), !0;
  return i.slideTo(S, e, s, t)
}

function ct(e, s = !0, t) {
  const i = this;
  if (!i.destroyed) return typeof e > "u" && (e = i.params.speed), i.slideTo(i.activeIndex, e, s, t)
}

function ft(e, s = !0, t, i = .5) {
  const r = this;
  if (r.destroyed) return;
  typeof e > "u" && (e = r.params.speed);
  let n = r.activeIndex;
  const l = Math.min(r.params.slidesPerGroupSkip, n),
    o = l + Math.floor((n - l) / r.params.slidesPerGroup),
    a = r.rtlTranslate ? r.translate : -r.translate;
  if (a >= r.snapGrid[o]) {
    const d = r.snapGrid[o],
      p = r.snapGrid[o + 1];
    a - d > (p - d) * i && (n += r.params.slidesPerGroup)
  } else {
    const d = r.snapGrid[o - 1],
      p = r.snapGrid[o];
    a - d <= (p - d) * i && (n -= r.params.slidesPerGroup)
  }
  return n = Math.max(n, 0), n = Math.min(n, r.slidesGrid.length - 1), r.slideTo(n, e, s, t)
}

function ut() {
  const e = this;
  if (e.destroyed) return;
  const {
    params: s,
    slidesEl: t
  } = e, i = s.slidesPerView === "auto" ? e.slidesPerViewDynamic() : s.slidesPerView;
  let r = e.getSlideIndexWhenGrid(e.clickedIndex),
    n;
  const l = e.isElement ? "swiper-slide" : `.${s.slideClass}`,
    o = e.grid && e.params.grid && e.params.grid.rows > 1;
  if (s.loop) {
    if (e.animating) return;
    n = parseInt(e.clickedSlide.getAttribute("data-swiper-slide-index"), 10), s.centeredSlides ? e.slideToLoop(n) : r > (o ? (e.slides.length - i) / 2 - (e.params.grid.rows - 1) : e.slides.length - i) ? (e.loopFix(), r = e.getSlideIndex(_(t, `${l}[data-swiper-slide-index="${n}"]`)[0]), me(() => {
      e.slideTo(r)
    })) : e.slideTo(r)
  } else e.slideTo(r)
}
var pt = {
  slideTo: at,
  slideToLoop: lt,
  slideNext: ot,
  slidePrev: dt,
  slideReset: ct,
  slideToClosest: ft,
  slideToClickedSlide: ut
};

function mt(e, s) {
  const t = this,
    {
      params: i,
      slidesEl: r
    } = t;
  if (!i.loop || t.virtual && t.params.virtual.enabled) return;
  const n = () => {
      _(r, `.${i.slideClass}, swiper-slide`).forEach((m, h) => {
        m.setAttribute("data-swiper-slide-index", h)
      })
    },
    l = () => {
      const f = _(r, `.${i.slideBlankClass}`);
      f.forEach(m => {
        m.remove()
      }), f.length > 0 && (t.recalcSlides(), t.updateSlides())
    },
    o = t.grid && i.grid && i.grid.rows > 1;
  i.loopAddBlankSlides && (i.slidesPerGroup > 1 || o) && l();
  const a = i.slidesPerGroup * (o ? i.grid.rows : 1),
    d = t.slides.length % a !== 0,
    p = o && t.slides.length % i.grid.rows !== 0,
    c = f => {
      for (let m = 0; m < f; m += 1) {
        const h = t.isElement ? te("swiper-slide", [i.slideBlankClass]) : te("div", [i.slideClass, i.slideBlankClass]);
        t.slidesEl.append(h)
      }
    };
  if (d) {
    if (i.loopAddBlankSlides) {
      const f = a - t.slides.length % a;
      c(f), t.recalcSlides(), t.updateSlides()
    } else Y("Swiper Loop Warning: The number of slides is not even to slidesPerGroup, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)");
    n()
  } else if (p) {
    if (i.loopAddBlankSlides) {
      const f = i.grid.rows - t.slides.length % i.grid.rows;
      c(f), t.recalcSlides(), t.updateSlides()
    } else Y("Swiper Loop Warning: The number of slides is not even to grid.rows, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)");
    n()
  } else n();
  const u = i.centeredSlides || !!i.slidesOffsetBefore || !!i.slidesOffsetAfter;
  t.loopFix({
    slideRealIndex: e,
    direction: u ? void 0 : "next",
    initial: s
  })
}

function ht({
  slideRealIndex: e,
  slideTo: s = !0,
  direction: t,
  setTranslate: i,
  activeSlideIndex: r,
  initial: n,
  byController: l,
  byMousewheel: o
} = {}) {
  const a = this;
  if (!a.params.loop) return;
  a.emit("beforeLoopFix");
  const {
    slides: d,
    allowSlidePrev: p,
    allowSlideNext: c,
    slidesEl: u,
    params: f
  } = a, {
    centeredSlides: m,
    slidesOffsetBefore: h,
    slidesOffsetAfter: b,
    initialSlide: S
  } = f, g = m || !!h || !!b;
  if (a.allowSlidePrev = !0, a.allowSlideNext = !0, a.virtual && f.virtual.enabled) {
    s && (!g && a.snapIndex === 0 ? a.slideTo(a.virtual.slides.length, 0, !1, !0) : g && a.snapIndex < f.slidesPerView ? a.slideTo(a.virtual.slides.length + a.snapIndex, 0, !1, !0) : a.snapIndex === a.snapGrid.length - 1 && a.slideTo(a.virtual.slidesBefore, 0, !1, !0)), a.allowSlidePrev = p, a.allowSlideNext = c, a.emit("loopFix");
    return
  }
  let v = f.slidesPerView;
  v === "auto" ? v = a.slidesPerViewDynamic() : (v = Math.ceil(parseFloat(f.slidesPerView, 10)), g && v % 2 === 0 && (v = v + 1));
  const E = f.slidesPerGroupAuto ? v : f.slidesPerGroup;
  let w = g ? Math.max(E, Math.ceil(v / 2)) : E;
  w % E !== 0 && (w += E - w % E), w += f.loopAdditionalSlides, a.loopedSlides = w;
  const I = a.grid && f.grid && f.grid.rows > 1;
  d.length < v + w || a.params.effect === "cards" && d.length < v + w * 2 ? Y("Swiper Loop Warning: The number of slides is not enough for loop mode, it will be disabled or not function properly. You need to add more slides (or make duplicates) or lower the values of slidesPerView and slidesPerGroup parameters") : I && f.grid.fill === "row" && Y("Swiper Loop Warning: Loop mode is not compatible with grid.fill = `row`");
  const M = [],
    y = [],
    L = I ? Math.ceil(d.length / f.grid.rows) : d.length,
    x = n && L - S < v && !g;
  let T = x ? S : a.activeIndex;
  typeof r > "u" ? r = a.getSlideIndex(d.find(P => P.classList.contains(f.slideActiveClass))) : T = r;
  const C = t === "next" || !t,
    z = t === "prev" || !t;
  let V = 0,
    B = 0;
  const $ = (I ? d[r].column : r) + (g && typeof i > "u" ? -v / 2 + .5 : 0);
  if ($ < w) {
    V = Math.max(w - $, E);
    for (let P = 0; P < w - $; P += 1) {
      const O = P - Math.floor(P / L) * L;
      if (I) {
        const k = L - O - 1;
        for (let F = d.length - 1; F >= 0; F -= 1) d[F].column === k && M.push(F)
      } else M.push(L - O - 1)
    }
  } else if ($ + v > L - w) {
    B = Math.max($ - (L - w * 2), E), x && (B = Math.max(B, v - L + S + 1));
    for (let P = 0; P < B; P += 1) {
      const O = P - Math.floor(P / L) * L;
      I ? d.forEach((k, F) => {
        k.column === O && y.push(F)
      }) : y.push(O)
    }
  }
  if (a.__preventObserver__ = !0, requestAnimationFrame(() => {
      a.__preventObserver__ = !1
    }), a.params.effect === "cards" && d.length < v + w * 2 && (y.includes(r) && y.splice(y.indexOf(r), 1), M.includes(r) && M.splice(M.indexOf(r), 1)), z && M.forEach(P => {
      d[P].swiperLoopMoveDOM = !0, u.prepend(d[P]), d[P].swiperLoopMoveDOM = !1
    }), C && y.forEach(P => {
      d[P].swiperLoopMoveDOM = !0, u.append(d[P]), d[P].swiperLoopMoveDOM = !1
    }), a.recalcSlides(), f.slidesPerView === "auto" ? a.updateSlides() : I && (M.length > 0 && z || y.length > 0 && C) && a.slides.forEach((P, O) => {
      a.grid.updateSlide(O, P, a.slides)
    }), f.watchSlidesProgress && a.updateSlidesOffset(), s) {
    if (M.length > 0 && z) {
      if (typeof e > "u") {
        const P = a.slidesGrid[T],
          k = a.slidesGrid[T + V] - P;
        o ? a.setTranslate(a.translate - k) : (a.slideTo(T + Math.ceil(V), 0, !1, !0), i && (a.touchEventsData.startTranslate = a.touchEventsData.startTranslate - k, a.touchEventsData.currentTranslate = a.touchEventsData.currentTranslate - k))
      } else if (i) {
        const P = I ? M.length / f.grid.rows : M.length;
        a.slideTo(a.activeIndex + P, 0, !1, !0), a.touchEventsData.currentTranslate = a.translate
      }
    } else if (y.length > 0 && C)
      if (typeof e > "u") {
        const P = a.slidesGrid[T],
          k = a.slidesGrid[T - B] - P;
        o ? a.setTranslate(a.translate - k) : (a.slideTo(T - B, 0, !1, !0), i && (a.touchEventsData.startTranslate = a.touchEventsData.startTranslate - k, a.touchEventsData.currentTranslate = a.touchEventsData.currentTranslate - k))
      } else {
        const P = I ? y.length / f.grid.rows : y.length;
        a.slideTo(a.activeIndex - P, 0, !1, !0)
      }
  }
  if (a.allowSlidePrev = p, a.allowSlideNext = c, a.controller && a.controller.control && !l) {
    const P = {
      slideRealIndex: e,
      direction: t,
      setTranslate: i,
      activeSlideIndex: r,
      byController: !0
    };
    Array.isArray(a.controller.control) ? a.controller.control.forEach(O => {
      !O.destroyed && O.params.loop && O.loopFix({
        ...P,
        slideTo: O.params.slidesPerView === f.slidesPerView ? s : !1
      })
    }) : a.controller.control instanceof a.constructor && a.controller.control.params.loop && a.controller.control.loopFix({
      ...P,
      slideTo: a.controller.control.params.slidesPerView === f.slidesPerView ? s : !1
    })
  }
  a.emit("loopFix")
}

function gt() {
  const e = this,
    {
      params: s,
      slidesEl: t
    } = e;
  if (!s.loop || !t || e.virtual && e.params.virtual.enabled) return;
  e.recalcSlides();
  const i = [];
  e.slides.forEach(r => {
    const n = typeof r.swiperSlideIndex > "u" ? r.getAttribute("data-swiper-slide-index") * 1 : r.swiperSlideIndex;
    i[n] = r
  }), e.slides.forEach(r => {
    r.removeAttribute("data-swiper-slide-index")
  }), i.forEach(r => {
    t.append(r)
  }), e.recalcSlides(), e.slideTo(e.realIndex, 0)
}
var vt = {
  loopCreate: mt,
  loopFix: ht,
  loopDestroy: gt
};

function wt(e) {
  const s = this;
  if (!s.params.simulateTouch || s.params.watchOverflow && s.isLocked || s.params.cssMode) return;
  const t = s.params.touchEventsTarget === "container" ? s.el : s.wrapperEl;
  s.isElement && (s.__preventObserver__ = !0), t.style.cursor = "move", t.style.cursor = e ? "grabbing" : "grab", s.isElement && requestAnimationFrame(() => {
    s.__preventObserver__ = !1
  })
}

function St() {
  const e = this;
  e.params.watchOverflow && e.isLocked || e.params.cssMode || (e.isElement && (e.__preventObserver__ = !0), e[e.params.touchEventsTarget === "container" ? "el" : "wrapperEl"].style.cursor = "", e.isElement && requestAnimationFrame(() => {
    e.__preventObserver__ = !1
  }))
}
var Tt = {
  setGrabCursor: wt,
  unsetGrabCursor: St
};

function bt(e, s = this) {
  function t(i) {
    if (!i || i === H() || i === A()) return null;
    i.assignedSlot && (i = i.assignedSlot);
    const r = i.closest(e);
    return !r && !i.getRootNode ? null : r || t(i.getRootNode().host)
  }
  return t(s)
}

function de(e, s, t) {
  const i = A(),
    {
      params: r
    } = e,
    n = r.edgeSwipeDetection,
    l = r.edgeSwipeThreshold;
  return n && (t <= l || t >= i.innerWidth - l) ? n === "prevent" ? (s.preventDefault(), !0) : !1 : !0
}

function yt(e) {
  const s = this,
    t = H();
  let i = e;
  i.originalEvent && (i = i.originalEvent);
  const r = s.touchEventsData;
  if (i.type === "pointerdown") {
    if (r.pointerId !== null && r.pointerId !== i.pointerId) return;
    r.pointerId = i.pointerId
  } else i.type === "touchstart" && i.targetTouches.length === 1 && (r.touchId = i.targetTouches[0].identifier);
  if (i.type === "touchstart") {
    de(s, i, i.targetTouches[0].pageX);
    return
  }
  const {
    params: n,
    touches: l,
    enabled: o
  } = s;
  if (!o || !n.simulateTouch && i.pointerType === "mouse" || s.animating && n.preventInteractionOnTransition) return;
  !s.animating && n.cssMode && n.loop && s.loopFix();
  let a = i.target;
  if (n.touchEventsTarget === "wrapper" && !Le(a, s.wrapperEl) || "which" in i && i.which === 3 || "button" in i && i.button > 0 || r.isTouched && r.isMoved) return;
  const d = !!n.noSwipingClass && n.noSwipingClass !== "",
    p = i.composedPath ? i.composedPath() : i.path;
  d && i.target && i.target.shadowRoot && p && (a = p[0]);
  const c = n.noSwipingSelector ? n.noSwipingSelector : `.${n.noSwipingClass}`,
    u = !!(i.target && i.target.shadowRoot);
  if (n.noSwiping && (u ? bt(c, a) : a.closest(c))) {
    s.allowClick = !0;
    return
  }
  if (n.swipeHandler && !a.closest(n.swipeHandler)) return;
  l.currentX = i.pageX, l.currentY = i.pageY;
  const f = l.currentX,
    m = l.currentY;
  if (!de(s, i, f)) return;
  Object.assign(r, {
    isTouched: !0,
    isMoved: !1,
    allowTouchCallbacks: !0,
    isScrolling: void 0,
    startMoving: void 0
  }), l.startX = f, l.startY = m, r.touchStartTime = j(), s.allowClick = !0, s.updateSize(), s.swipeDirection = void 0, n.threshold > 0 && (r.allowThresholdMove = !1);
  let h = !0;
  a.matches(r.focusableElements) && (h = !1, a.nodeName === "SELECT" && (r.isTouched = !1)), t.activeElement && t.activeElement.matches(r.focusableElements) && t.activeElement !== a && (i.pointerType === "mouse" || i.pointerType !== "mouse" && !a.matches(r.focusableElements)) && t.activeElement.blur();
  const b = h && s.allowTouchMove && n.touchStartPreventDefault;
  (n.touchStartForcePreventDefault || b) && !a.isContentEditable && i.preventDefault(), n.freeMode && n.freeMode.enabled && s.freeMode && s.animating && !n.cssMode && s.freeMode.onTouchStart(), s.emit("touchStart", i)
}

function xt(e) {
  const s = H(),
    t = this,
    i = t.touchEventsData,
    {
      params: r,
      touches: n,
      rtlTranslate: l,
      enabled: o
    } = t;
  if (!o || !r.simulateTouch && e.pointerType === "mouse") return;
  let a = e;
  if (a.originalEvent && (a = a.originalEvent), a.type === "pointermove" && (i.touchId !== null || a.pointerId !== i.pointerId)) return;
  let d;
  if (a.type === "touchmove") {
    if (d = [...a.changedTouches].find(w => w.identifier === i.touchId), !d || d.identifier !== i.touchId) return
  } else d = a;
  if (!i.isTouched) {
    i.startMoving && i.isScrolling && t.emit("touchMoveOpposite", a);
    return
  }
  const p = d.pageX,
    c = d.pageY;
  if (a.preventedByNestedSwiper) {
    n.startX = p, n.startY = c;
    return
  }
  if (!t.allowTouchMove) {
    a.target.matches(i.focusableElements) || (t.allowClick = !1), i.isTouched && (Object.assign(n, {
      startX: p,
      startY: c,
      currentX: p,
      currentY: c
    }), i.touchStartTime = j());
    return
  }
  if (r.touchReleaseOnEdges && !r.loop)
    if (t.isVertical()) {
      if (c < n.startY && t.translate <= t.maxTranslate() || c > n.startY && t.translate >= t.minTranslate()) {
        i.isTouched = !1, i.isMoved = !1;
        return
      }
    } else {
      if (l && (p > n.startX && -t.translate <= t.maxTranslate() || p < n.startX && -t.translate >= t.minTranslate())) return;
      if (!l && (p < n.startX && t.translate <= t.maxTranslate() || p > n.startX && t.translate >= t.minTranslate())) return
    } if (s.activeElement && s.activeElement.matches(i.focusableElements) && s.activeElement !== a.target && a.pointerType !== "mouse" && s.activeElement.blur(), s.activeElement && a.target === s.activeElement && a.target.matches(i.focusableElements)) {
    i.isMoved = !0, t.allowClick = !1;
    return
  }
  i.allowTouchCallbacks && t.emit("touchMove", a), n.previousX = n.currentX, n.previousY = n.currentY, n.currentX = p, n.currentY = c;
  const u = n.currentX - n.startX,
    f = n.currentY - n.startY;
  if (t.params.threshold && Math.sqrt(u ** 2 + f ** 2) < t.params.threshold) return;
  if (typeof i.isScrolling > "u") {
    let w;
    t.isHorizontal() && n.currentY === n.startY || t.isVertical() && n.currentX === n.startX ? i.isScrolling = !1 : u * u + f * f >= 25 && (w = Math.atan2(Math.abs(f), Math.abs(u)) * 180 / Math.PI, i.isScrolling = t.isHorizontal() ? w > r.touchAngle : 90 - w > r.touchAngle)
  }
  if (i.isScrolling && t.emit("touchMoveOpposite", a), typeof i.startMoving > "u" && (n.currentX !== n.startX || n.currentY !== n.startY) && (i.startMoving = !0), i.isScrolling || a.type === "touchmove" && i.preventTouchMoveFromPointerMove) {
    i.isTouched = !1;
    return
  }
  if (!i.startMoving) return;
  t.allowClick = !1, !r.cssMode && a.cancelable && a.preventDefault(), r.touchMoveStopPropagation && !r.nested && a.stopPropagation();
  let m = t.isHorizontal() ? u : f,
    h = t.isHorizontal() ? n.currentX - n.previousX : n.currentY - n.previousY;
  r.oneWayMovement && (m = Math.abs(m) * (l ? 1 : -1), h = Math.abs(h) * (l ? 1 : -1)), n.diff = m, m *= r.touchRatio, l && (m = -m, h = -h);
  const b = t.touchesDirection;
  t.swipeDirection = m > 0 ? "prev" : "next", t.touchesDirection = h > 0 ? "prev" : "next";
  const S = t.params.loop && !r.cssMode,
    g = t.touchesDirection === "next" && t.allowSlideNext || t.touchesDirection === "prev" && t.allowSlidePrev;
  if (!i.isMoved) {
    if (S && g && t.loopFix({
        direction: t.swipeDirection
      }), i.startTranslate = t.getTranslate(), t.setTransition(0), t.animating) {
      const w = new window.CustomEvent("transitionend", {
        bubbles: !0,
        cancelable: !0,
        detail: {
          bySwiperTouchMove: !0
        }
      });
      t.wrapperEl.dispatchEvent(w)
    }
    i.allowMomentumBounce = !1, r.grabCursor && (t.allowSlideNext === !0 || t.allowSlidePrev === !0) && t.setGrabCursor(!0), t.emit("sliderFirstMove", a)
  }
  if (new Date().getTime(), r._loopSwapReset !== !1 && i.isMoved && i.allowThresholdMove && b !== t.touchesDirection && S && g && Math.abs(m) >= 1) {
    Object.assign(n, {
      startX: p,
      startY: c,
      currentX: p,
      currentY: c,
      startTranslate: i.currentTranslate
    }), i.loopSwapReset = !0, i.startTranslate = i.currentTranslate;
    return
  }
  t.emit("sliderMove", a), i.isMoved = !0, i.currentTranslate = m + i.startTranslate;
  let v = !0,
    E = r.resistanceRatio;
  if (r.touchReleaseOnEdges && (E = 0), m > 0 ? (S && g && i.allowThresholdMove && i.currentTranslate > (r.centeredSlides ? t.minTranslate() - t.slidesSizesGrid[t.activeIndex + 1] - (r.slidesPerView !== "auto" && t.slides.length - r.slidesPerView >= 2 ? t.slidesSizesGrid[t.activeIndex + 1] + t.params.spaceBetween : 0) - t.params.spaceBetween : t.minTranslate()) && t.loopFix({
      direction: "prev",
      setTranslate: !0,
      activeSlideIndex: 0
    }), i.currentTranslate > t.minTranslate() && (v = !1, r.resistance && (i.currentTranslate = t.minTranslate() - 1 + (-t.minTranslate() + i.startTranslate + m) ** E))) : m < 0 && (S && g && i.allowThresholdMove && i.currentTranslate < (r.centeredSlides ? t.maxTranslate() + t.slidesSizesGrid[t.slidesSizesGrid.length - 1] + t.params.spaceBetween + (r.slidesPerView !== "auto" && t.slides.length - r.slidesPerView >= 2 ? t.slidesSizesGrid[t.slidesSizesGrid.length - 1] + t.params.spaceBetween : 0) : t.maxTranslate()) && t.loopFix({
      direction: "next",
      setTranslate: !0,
      activeSlideIndex: t.slides.length - (r.slidesPerView === "auto" ? t.slidesPerViewDynamic() : Math.ceil(parseFloat(r.slidesPerView, 10)))
    }), i.currentTranslate < t.maxTranslate() && (v = !1, r.resistance && (i.currentTranslate = t.maxTranslate() + 1 - (t.maxTranslate() - i.startTranslate - m) ** E))), v && (a.preventedByNestedSwiper = !0), !t.allowSlideNext && t.swipeDirection === "next" && i.currentTranslate < i.startTranslate && (i.currentTranslate = i.startTranslate), !t.allowSlidePrev && t.swipeDirection === "prev" && i.currentTranslate > i.startTranslate && (i.currentTranslate = i.startTranslate), !t.allowSlidePrev && !t.allowSlideNext && (i.currentTranslate = i.startTranslate), r.threshold > 0)
    if (Math.abs(m) > r.threshold || i.allowThresholdMove) {
      if (!i.allowThresholdMove) {
        i.allowThresholdMove = !0, n.startX = n.currentX, n.startY = n.currentY, i.currentTranslate = i.startTranslate, n.diff = t.isHorizontal() ? n.currentX - n.startX : n.currentY - n.startY;
        return
      }
    } else {
      i.currentTranslate = i.startTranslate;
      return
    }! r.followFinger || r.cssMode || ((r.freeMode && r.freeMode.enabled && t.freeMode || r.watchSlidesProgress) && (t.updateActiveIndex(), t.updateSlidesClasses()), r.freeMode && r.freeMode.enabled && t.freeMode && t.freeMode.onTouchMove(), t.updateProgress(i.currentTranslate), t.setTranslate(i.currentTranslate))
}

function Et(e) {
  const s = this,
    t = s.touchEventsData;
  let i = e;
  i.originalEvent && (i = i.originalEvent);
  let r;
  if (i.type === "touchend" || i.type === "touchcancel") {
    if (r = [...i.changedTouches].find(w => w.identifier === t.touchId), !r || r.identifier !== t.touchId) return
  } else {
    if (t.touchId !== null || i.pointerId !== t.pointerId) return;
    r = i
  }
  if (["pointercancel", "pointerout", "pointerleave", "contextmenu"].includes(i.type) && !(["pointercancel", "contextmenu"].includes(i.type) && (s.browser.isSafari || s.browser.isWebView))) return;
  t.pointerId = null, t.touchId = null;
  const {
    params: l,
    touches: o,
    rtlTranslate: a,
    slidesGrid: d,
    enabled: p
  } = s;
  if (!p || !l.simulateTouch && i.pointerType === "mouse") return;
  if (t.allowTouchCallbacks && s.emit("touchEnd", i), t.allowTouchCallbacks = !1, !t.isTouched) {
    t.isMoved && l.grabCursor && s.setGrabCursor(!1), t.isMoved = !1, t.startMoving = !1;
    return
  }
  l.grabCursor && t.isMoved && t.isTouched && (s.allowSlideNext === !0 || s.allowSlidePrev === !0) && s.setGrabCursor(!1);
  const c = j(),
    u = c - t.touchStartTime;
  if (s.allowClick) {
    const w = i.path || i.composedPath && i.composedPath();
    s.updateClickedSlide(w && w[0] || i.target, w), s.emit("tap click", i), u < 300 && c - t.lastClickTime < 300 && s.emit("doubleTap doubleClick", i)
  }
  if (t.lastClickTime = j(), me(() => {
      s.destroyed || (s.allowClick = !0)
    }), !t.isTouched || !t.isMoved || !s.swipeDirection || o.diff === 0 && !t.loopSwapReset || t.currentTranslate === t.startTranslate && !t.loopSwapReset) {
    t.isTouched = !1, t.isMoved = !1, t.startMoving = !1;
    return
  }
  t.isTouched = !1, t.isMoved = !1, t.startMoving = !1;
  let f;
  if (l.followFinger ? f = a ? s.translate : -s.translate : f = -t.currentTranslate, l.cssMode) return;
  if (l.freeMode && l.freeMode.enabled) {
    s.freeMode.onTouchEnd({
      currentPos: f
    });
    return
  }
  const m = f >= -s.maxTranslate() && !s.params.loop;
  let h = 0,
    b = s.slidesSizesGrid[0];
  for (let w = 0; w < d.length; w += w < l.slidesPerGroupSkip ? 1 : l.slidesPerGroup) {
    const I = w < l.slidesPerGroupSkip - 1 ? 1 : l.slidesPerGroup;
    typeof d[w + I] < "u" ? (m || f >= d[w] && f < d[w + I]) && (h = w, b = d[w + I] - d[w]) : (m || f >= d[w]) && (h = w, b = d[d.length - 1] - d[d.length - 2])
  }
  let S = null,
    g = null;
  l.rewind && (s.isBeginning ? g = l.virtual && l.virtual.enabled && s.virtual ? s.virtual.slides.length - 1 : s.slides.length - 1 : s.isEnd && (S = 0));
  const v = (f - d[h]) / b,
    E = h < l.slidesPerGroupSkip - 1 ? 1 : l.slidesPerGroup;
  if (u > l.longSwipesMs) {
    if (!l.longSwipes) {
      s.slideTo(s.activeIndex);
      return
    }
    s.swipeDirection === "next" && (v >= l.longSwipesRatio ? s.slideTo(l.rewind && s.isEnd ? S : h + E) : s.slideTo(h)), s.swipeDirection === "prev" && (v > 1 - l.longSwipesRatio ? s.slideTo(h + E) : g !== null && v < 0 && Math.abs(v) > l.longSwipesRatio ? s.slideTo(g) : s.slideTo(h))
  } else {
    if (!l.shortSwipes) {
      s.slideTo(s.activeIndex);
      return
    }
    s.navigation && (i.target === s.navigation.nextEl || i.target === s.navigation.prevEl) ? i.target === s.navigation.nextEl ? s.slideTo(h + E) : s.slideTo(h) : (s.swipeDirection === "next" && s.slideTo(S !== null ? S : h + E), s.swipeDirection === "prev" && s.slideTo(g !== null ? g : h))
  }
}

function ce() {
  const e = this,
    {
      params: s,
      el: t
    } = e;
  if (t && t.offsetWidth === 0) return;
  s.breakpoints && e.setBreakpoint();
  const {
    allowSlideNext: i,
    allowSlidePrev: r,
    snapGrid: n
  } = e, l = e.virtual && e.params.virtual.enabled;
  e.allowSlideNext = !0, e.allowSlidePrev = !0, e.updateSize(), e.updateSlides(), e.updateSlidesClasses();
  const o = l && s.loop;
  (s.slidesPerView === "auto" || s.slidesPerView > 1) && e.isEnd && !e.isBeginning && !e.params.centeredSlides && !o ? e.slideTo(e.slides.length - 1, 0, !1, !0) : e.params.loop && !l ? e.slideToLoop(e.realIndex, 0, !1, !0) : e.slideTo(e.activeIndex, 0, !1, !0), e.autoplay && e.autoplay.running && e.autoplay.paused && (clearTimeout(e.autoplay.resizeTimeout), e.autoplay.resizeTimeout = setTimeout(() => {
    e.autoplay && e.autoplay.running && e.autoplay.paused && e.autoplay.resume()
  }, 500)), e.allowSlidePrev = r, e.allowSlideNext = i, e.params.watchOverflow && n !== e.snapGrid && e.checkOverflow()
}

function Mt(e) {
  const s = this;
  s.enabled && (s.allowClick || (s.params.preventClicks && e.preventDefault(), s.params.preventClicksPropagation && s.animating && (e.stopPropagation(), e.stopImmediatePropagation())))
}

function Pt() {
  const e = this,
    {
      wrapperEl: s,
      rtlTranslate: t,
      enabled: i
    } = e;
  if (!i) return;
  e.previousTranslate = e.translate, e.isHorizontal() ? e.translate = -s.scrollLeft : e.translate = -s.scrollTop, e.translate === 0 && (e.translate = 0), e.updateActiveIndex(), e.updateSlidesClasses();
  let r;
  const n = e.maxTranslate() - e.minTranslate();
  n === 0 ? r = 0 : r = (e.translate - e.minTranslate()) / n, r !== e.progress && e.updateProgress(t ? -e.translate : e.translate), e.emit("setTranslate", e.translate, !1)
}

function Ct(e) {
  const s = this;
  W(s, e.target), !(s.params.cssMode || s.params.slidesPerView !== "auto" && !s.params.autoHeight) && s.update()
}

function It() {
  const e = this;
  e.documentTouchHandlerProceeded || (e.documentTouchHandlerProceeded = !0, e.params.touchReleaseOnEdges && (e.el.style.touchAction = "auto"))
}
const Te = (e, s) => {
  const t = H(),
    {
      params: i,
      el: r,
      wrapperEl: n,
      device: l
    } = e,
    o = !!i.nested,
    a = s === "on" ? "addEventListener" : "removeEventListener",
    d = s;
  !r || typeof r == "string" || (t[a]("touchstart", e.onDocumentTouchStart, {
    passive: !1,
    capture: o
  }), r[a]("touchstart", e.onTouchStart, {
    passive: !1
  }), r[a]("pointerdown", e.onTouchStart, {
    passive: !1
  }), t[a]("touchmove", e.onTouchMove, {
    passive: !1,
    capture: o
  }), t[a]("pointermove", e.onTouchMove, {
    passive: !1,
    capture: o
  }), t[a]("touchend", e.onTouchEnd, {
    passive: !0
  }), t[a]("pointerup", e.onTouchEnd, {
    passive: !0
  }), t[a]("pointercancel", e.onTouchEnd, {
    passive: !0
  }), t[a]("touchcancel", e.onTouchEnd, {
    passive: !0
  }), t[a]("pointerout", e.onTouchEnd, {
    passive: !0
  }), t[a]("pointerleave", e.onTouchEnd, {
    passive: !0
  }), t[a]("contextmenu", e.onTouchEnd, {
    passive: !0
  }), (i.preventClicks || i.preventClicksPropagation) && r[a]("click", e.onClick, !0), i.cssMode && n[a]("scroll", e.onScroll), i.updateOnWindowResize ? e[d](l.ios || l.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", ce, !0) : e[d]("observerUpdate", ce, !0), r[a]("load", e.onLoad, {
    capture: !0
  }))
};

function Lt() {
  const e = this,
    {
      params: s
    } = e;
  e.onTouchStart = yt.bind(e), e.onTouchMove = xt.bind(e), e.onTouchEnd = Et.bind(e), e.onDocumentTouchStart = It.bind(e), s.cssMode && (e.onScroll = Pt.bind(e)), e.onClick = Mt.bind(e), e.onLoad = Ct.bind(e), Te(e, "on")
}

function Ot() {
  Te(this, "off")
}
var At = {
  attachEvents: Lt,
  detachEvents: Ot
};
const fe = (e, s) => e.grid && s.grid && s.grid.rows > 1;

function zt() {
  const e = this,
    {
      realIndex: s,
      initialized: t,
      params: i,
      el: r
    } = e,
    n = i.breakpoints;
  if (!n || n && Object.keys(n).length === 0) return;
  const l = H(),
    o = i.breakpointsBase === "window" || !i.breakpointsBase ? i.breakpointsBase : "container",
    a = ["window", "container"].includes(i.breakpointsBase) || !i.breakpointsBase ? e.el : l.querySelector(i.breakpointsBase),
    d = e.getBreakpoint(n, o, a);
  if (!d || e.currentBreakpoint === d) return;
  const c = (d in n ? n[d] : void 0) || e.originalParams,
    u = fe(e, i),
    f = fe(e, c),
    m = e.params.grabCursor,
    h = c.grabCursor,
    b = i.enabled;
  u && !f ? (r.classList.remove(`${i.containerModifierClass}grid`, `${i.containerModifierClass}grid-column`), e.emitContainerClasses()) : !u && f && (r.classList.add(`${i.containerModifierClass}grid`), (c.grid.fill && c.grid.fill === "column" || !c.grid.fill && i.grid.fill === "column") && r.classList.add(`${i.containerModifierClass}grid-column`), e.emitContainerClasses()), m && !h ? e.unsetGrabCursor() : !m && h && e.setGrabCursor(), ["navigation", "pagination", "scrollbar"].forEach(I => {
    if (typeof c[I] > "u") return;
    const M = i[I] && i[I].enabled,
      y = c[I] && c[I].enabled;
    M && !y && e[I].disable(), !M && y && e[I].enable()
  });
  const S = c.direction && c.direction !== i.direction,
    g = i.loop && (c.slidesPerView !== i.slidesPerView || S),
    v = i.loop;
  S && t && e.changeDirection(), G(e.params, c);
  const E = e.params.enabled,
    w = e.params.loop;
  Object.assign(e, {
    allowTouchMove: e.params.allowTouchMove,
    allowSlideNext: e.params.allowSlideNext,
    allowSlidePrev: e.params.allowSlidePrev
  }), b && !E ? e.disable() : !b && E && e.enable(), e.currentBreakpoint = d, e.emit("_beforeBreakpoint", c), t && (g ? (e.loopDestroy(), e.loopCreate(s), e.updateSlides()) : !v && w ? (e.loopCreate(s), e.updateSlides()) : v && !w && e.loopDestroy()), e.emit("breakpoint", c)
}

function kt(e, s = "window", t) {
  if (!e || s === "container" && !t) return;
  let i = !1;
  const r = A(),
    n = s === "window" ? r.innerHeight : t.clientHeight,
    l = Object.keys(e).map(o => {
      if (typeof o == "string" && o.indexOf("@") === 0) {
        const a = parseFloat(o.substr(1));
        return {
          value: n * a,
          point: o
        }
      }
      return {
        value: o,
        point: o
      }
    });
  l.sort((o, a) => parseInt(o.value, 10) - parseInt(a.value, 10));
  for (let o = 0; o < l.length; o += 1) {
    const {
      point: a,
      value: d
    } = l[o];
    s === "window" ? r.matchMedia(`(min-width: ${d}px)`).matches && (i = a) : d <= t.clientWidth && (i = a)
  }
  return i || "max"
}
var Gt = {
  setBreakpoint: zt,
  getBreakpoint: kt
};

function Dt(e, s) {
  const t = [];
  return e.forEach(i => {
    typeof i == "object" ? Object.keys(i).forEach(r => {
      i[r] && t.push(s + r)
    }) : typeof i == "string" && t.push(s + i)
  }), t
}

function Vt() {
  const e = this,
    {
      classNames: s,
      params: t,
      rtl: i,
      el: r,
      device: n
    } = e,
    l = Dt(["initialized", t.direction, {
      "free-mode": e.params.freeMode && t.freeMode.enabled
    }, {
      autoheight: t.autoHeight
    }, {
      rtl: i
    }, {
      grid: t.grid && t.grid.rows > 1
    }, {
      "grid-column": t.grid && t.grid.rows > 1 && t.grid.fill === "column"
    }, {
      android: n.android
    }, {
      ios: n.ios
    }, {
      "css-mode": t.cssMode
    }, {
      centered: t.cssMode && t.centeredSlides
    }, {
      "watch-progress": t.watchSlidesProgress
    }], t.containerModifierClass);
  s.push(...l), r.classList.add(...s), e.emitContainerClasses()
}

function _t() {
  const e = this,
    {
      el: s,
      classNames: t
    } = e;
  !s || typeof s == "string" || (s.classList.remove(...t), e.emitContainerClasses())
}
var Bt = {
  addClasses: Vt,
  removeClasses: _t
};

function Ft() {
  const e = this,
    {
      isLocked: s,
      params: t
    } = e,
    {
      slidesOffsetBefore: i
    } = t;
  if (i) {
    const r = e.slides.length - 1,
      n = e.slidesGrid[r] + e.slidesSizesGrid[r] + i * 2;
    e.isLocked = e.size > n
  } else e.isLocked = e.snapGrid.length === 1;
  t.allowSlideNext === !0 && (e.allowSlideNext = !e.isLocked), t.allowSlidePrev === !0 && (e.allowSlidePrev = !e.isLocked), s && s !== e.isLocked && (e.isEnd = !1), s !== e.isLocked && e.emit(e.isLocked ? "lock" : "unlock")
}
var Nt = {
    checkOverflow: Ft
  },
  ue = {
    init: !0,
    direction: "horizontal",
    oneWayMovement: !1,
    swiperElementNodeName: "SWIPER-CONTAINER",
    touchEventsTarget: "wrapper",
    initialSlide: 0,
    speed: 300,
    cssMode: !1,
    updateOnWindowResize: !0,
    resizeObserver: !0,
    nested: !1,
    createElements: !1,
    eventsPrefix: "swiper",
    enabled: !0,
    focusableElements: "input, select, option, textarea, button, video, label",
    width: null,
    height: null,
    preventInteractionOnTransition: !1,
    userAgent: null,
    url: null,
    edgeSwipeDetection: !1,
    edgeSwipeThreshold: 20,
    autoHeight: !1,
    setWrapperSize: !1,
    virtualTranslate: !1,
    effect: "slide",
    breakpoints: void 0,
    breakpointsBase: "window",
    spaceBetween: 0,
    slidesPerView: 1,
    slidesPerGroup: 1,
    slidesPerGroupSkip: 0,
    slidesPerGroupAuto: !1,
    centeredSlides: !1,
    centeredSlidesBounds: !1,
    slidesOffsetBefore: 0,
    slidesOffsetAfter: 0,
    normalizeSlideIndex: !0,
    centerInsufficientSlides: !1,
    watchOverflow: !0,
    roundLengths: !1,
    touchRatio: 1,
    touchAngle: 45,
    simulateTouch: !0,
    shortSwipes: !0,
    longSwipes: !0,
    longSwipesRatio: .5,
    longSwipesMs: 300,
    followFinger: !0,
    allowTouchMove: !0,
    threshold: 5,
    touchMoveStopPropagation: !1,
    touchStartPreventDefault: !0,
    touchStartForcePreventDefault: !1,
    touchReleaseOnEdges: !1,
    uniqueNavElements: !0,
    resistance: !0,
    resistanceRatio: .85,
    watchSlidesProgress: !1,
    grabCursor: !1,
    preventClicks: !0,
    preventClicksPropagation: !0,
    slideToClickedSlide: !1,
    loop: !1,
    loopAddBlankSlides: !0,
    loopAdditionalSlides: 0,
    loopPreventsSliding: !0,
    rewind: !1,
    allowSlidePrev: !0,
    allowSlideNext: !0,
    swipeHandler: null,
    noSwiping: !0,
    noSwipingClass: "swiper-no-swiping",
    noSwipingSelector: null,
    passiveListeners: !0,
    maxBackfaceHiddenSlides: 10,
    containerModifierClass: "swiper-",
    slideClass: "swiper-slide",
    slideBlankClass: "swiper-slide-blank",
    slideActiveClass: "swiper-slide-active",
    slideVisibleClass: "swiper-slide-visible",
    slideFullyVisibleClass: "swiper-slide-fully-visible",
    slideNextClass: "swiper-slide-next",
    slidePrevClass: "swiper-slide-prev",
    wrapperClass: "swiper-wrapper",
    lazyPreloaderClass: "swiper-lazy-preloader",
    lazyPreloadPrevNext: 0,
    runCallbacksOnInit: !0,
    _emitClasses: !1
  };

function $t(e, s) {
  return function(i = {}) {
    const r = Object.keys(i)[0],
      n = i[r];
    if (typeof n != "object" || n === null) {
      G(s, i);
      return
    }
    if (e[r] === !0 && (e[r] = {
        enabled: !0
      }), r === "navigation" && e[r] && e[r].enabled && !e[r].prevEl && !e[r].nextEl && (e[r].auto = !0), ["pagination", "scrollbar"].indexOf(r) >= 0 && e[r] && e[r].enabled && !e[r].el && (e[r].auto = !0), !(r in e && "enabled" in n)) {
      G(s, i);
      return
    }
    typeof e[r] == "object" && !("enabled" in e[r]) && (e[r].enabled = !0), e[r] || (e[r] = {
      enabled: !1
    }), G(s, i)
  }
}
const Z = {
    eventsEmitter: Be,
    update: Ue,
    translate: tt,
    transition: nt,
    slide: pt,
    loop: vt,
    grabCursor: Tt,
    events: At,
    breakpoints: Gt,
    checkOverflow: Nt,
    classes: Bt
  },
  ee = {};
class D {
  constructor(...s) {
    let t, i;
    s.length === 1 && s[0].constructor && Object.prototype.toString.call(s[0]).slice(8, -1) === "Object" ? i = s[0] : [t, i] = s, i || (i = {}), i = G({}, i), t && !i.el && (i.el = t);
    const r = H();
    if (i.el && typeof i.el == "string" && r.querySelectorAll(i.el).length > 1) {
      const a = [];
      return r.querySelectorAll(i.el).forEach(d => {
        const p = G({}, i, {
          el: d
        });
        a.push(new D(p))
      }), a
    }
    const n = this;
    n.__swiper__ = !0, n.support = ge(), n.device = ve({
      userAgent: i.userAgent
    }), n.browser = we(), n.eventsListeners = {}, n.eventsAnyListeners = [], n.modules = [...n.__modules__], i.modules && Array.isArray(i.modules) && n.modules.push(...i.modules);
    const l = {};
    n.modules.forEach(a => {
      a({
        params: i,
        swiper: n,
        extendParams: $t(i, l),
        on: n.on.bind(n),
        once: n.once.bind(n),
        off: n.off.bind(n),
        emit: n.emit.bind(n)
      })
    });
    const o = G({}, ue, l);
    return n.params = G({}, o, ee, i), n.originalParams = G({}, n.params), n.passedParams = G({}, i), n.params && n.params.on && Object.keys(n.params.on).forEach(a => {
      n.on(a, n.params.on[a])
    }), n.params && n.params.onAny && n.onAny(n.params.onAny), Object.assign(n, {
      enabled: n.params.enabled,
      el: t,
      classNames: [],
      slides: [],
      slidesGrid: [],
      snapGrid: [],
      slidesSizesGrid: [],
      isHorizontal() {
        return n.params.direction === "horizontal"
      },
      isVertical() {
        return n.params.direction === "vertical"
      },
      activeIndex: 0,
      realIndex: 0,
      isBeginning: !0,
      isEnd: !1,
      translate: 0,
      previousTranslate: 0,
      progress: 0,
      velocity: 0,
      animating: !1,
      cssOverflowAdjustment() {
        return Math.trunc(this.translate / 2 ** 23) * 2 ** 23
      },
      allowSlideNext: n.params.allowSlideNext,
      allowSlidePrev: n.params.allowSlidePrev,
      touchEventsData: {
        isTouched: void 0,
        isMoved: void 0,
        allowTouchCallbacks: void 0,
        touchStartTime: void 0,
        isScrolling: void 0,
        currentTranslate: void 0,
        startTranslate: void 0,
        allowThresholdMove: void 0,
        focusableElements: n.params.focusableElements,
        lastClickTime: 0,
        clickTimeout: void 0,
        velocities: [],
        allowMomentumBounce: void 0,
        startMoving: void 0,
        pointerId: null,
        touchId: null
      },
      allowClick: !0,
      allowTouchMove: n.params.allowTouchMove,
      touches: {
        startX: 0,
        startY: 0,
        currentX: 0,
        currentY: 0,
        diff: 0
      },
      imagesToLoad: [],
      imagesLoaded: 0
    }), n.emit("_swiper"), n.params.init && n.init(), n
  }
  getDirectionLabel(s) {
    return this.isHorizontal() ? s : {
      width: "height",
      "margin-top": "margin-left",
      "margin-bottom ": "margin-right",
      "margin-left": "margin-top",
      "margin-right": "margin-bottom",
      "padding-left": "padding-top",
      "padding-right": "padding-bottom",
      marginRight: "marginBottom"
    } [s]
  }
  getSlideIndex(s) {
    const {
      slidesEl: t,
      params: i
    } = this, r = _(t, `.${i.slideClass}, swiper-slide`), n = ae(r[0]);
    return ae(s) - n
  }
  getSlideIndexByData(s) {
    return this.getSlideIndex(this.slides.find(t => t.getAttribute("data-swiper-slide-index") * 1 === s))
  }
  getSlideIndexWhenGrid(s) {
    return this.grid && this.params.grid && this.params.grid.rows > 1 && (this.params.grid.fill === "column" ? s = Math.floor(s / this.params.grid.rows) : this.params.grid.fill === "row" && (s = s % Math.ceil(this.slides.length / this.params.grid.rows))), s
  }
  recalcSlides() {
    const s = this,
      {
        slidesEl: t,
        params: i
      } = s;
    s.slides = _(t, `.${i.slideClass}, swiper-slide`)
  }
  enable() {
    const s = this;
    s.enabled || (s.enabled = !0, s.params.grabCursor && s.setGrabCursor(), s.emit("enable"))
  }
  disable() {
    const s = this;
    s.enabled && (s.enabled = !1, s.params.grabCursor && s.unsetGrabCursor(), s.emit("disable"))
  }
  setProgress(s, t) {
    const i = this;
    s = Math.min(Math.max(s, 0), 1);
    const r = i.minTranslate(),
      l = (i.maxTranslate() - r) * s + r;
    i.translateTo(l, typeof t > "u" ? 0 : t), i.updateActiveIndex(), i.updateSlidesClasses()
  }
  emitContainerClasses() {
    const s = this;
    if (!s.params._emitClasses || !s.el) return;
    const t = s.el.className.split(" ").filter(i => i.indexOf("swiper") === 0 || i.indexOf(s.params.containerModifierClass) === 0);
    s.emit("_containerClasses", t.join(" "))
  }
  getSlideClasses(s) {
    const t = this;
    return t.destroyed ? "" : s.className.split(" ").filter(i => i.indexOf("swiper-slide") === 0 || i.indexOf(t.params.slideClass) === 0).join(" ")
  }
  emitSlidesClasses() {
    const s = this;
    if (!s.params._emitClasses || !s.el) return;
    const t = [];
    s.slides.forEach(i => {
      const r = s.getSlideClasses(i);
      t.push({
        slideEl: i,
        classNames: r
      }), s.emit("_slideClass", i, r)
    }), s.emit("_slideClasses", t)
  }
  slidesPerViewDynamic(s = "current", t = !1) {
    const i = this,
      {
        params: r,
        slides: n,
        slidesGrid: l,
        slidesSizesGrid: o,
        size: a,
        activeIndex: d
      } = i;
    let p = 1;
    if (typeof r.slidesPerView == "number") return r.slidesPerView;
    if (r.centeredSlides) {
      let c = n[d] ? Math.ceil(n[d].swiperSlideSize) : 0,
        u;
      for (let f = d + 1; f < n.length; f += 1) n[f] && !u && (c += Math.ceil(n[f].swiperSlideSize), p += 1, c > a && (u = !0));
      for (let f = d - 1; f >= 0; f -= 1) n[f] && !u && (c += n[f].swiperSlideSize, p += 1, c > a && (u = !0))
    } else if (s === "current")
      for (let c = d + 1; c < n.length; c += 1)(t ? l[c] + o[c] - l[d] < a : l[c] - l[d] < a) && (p += 1);
    else
      for (let c = d - 1; c >= 0; c -= 1) l[d] - l[c] < a && (p += 1);
    return p
  }
  update() {
    const s = this;
    if (!s || s.destroyed) return;
    const {
      snapGrid: t,
      params: i
    } = s;
    i.breakpoints && s.setBreakpoint(), [...s.el.querySelectorAll('[loading="lazy"]')].forEach(l => {
      l.complete && W(s, l)
    }), s.updateSize(), s.updateSlides(), s.updateProgress(), s.updateSlidesClasses();

    function r() {
      const l = s.rtlTranslate ? s.translate * -1 : s.translate,
        o = Math.min(Math.max(l, s.maxTranslate()), s.minTranslate());
      s.setTranslate(o), s.updateActiveIndex(), s.updateSlidesClasses()
    }
    let n;
    if (i.freeMode && i.freeMode.enabled && !i.cssMode) r(), i.autoHeight && s.updateAutoHeight();
    else {
      if ((i.slidesPerView === "auto" || i.slidesPerView > 1) && s.isEnd && !i.centeredSlides) {
        const l = s.virtual && i.virtual.enabled ? s.virtual.slides : s.slides;
        n = s.slideTo(l.length - 1, 0, !1, !0)
      } else n = s.slideTo(s.activeIndex, 0, !1, !0);
      n || r()
    }
    i.watchOverflow && t !== s.snapGrid && s.checkOverflow(), s.emit("update")
  }
  changeDirection(s, t = !0) {
    const i = this,
      r = i.params.direction;
    return s || (s = r === "horizontal" ? "vertical" : "horizontal"), s === r || s !== "horizontal" && s !== "vertical" || (i.el.classList.remove(`${i.params.containerModifierClass}${r}`), i.el.classList.add(`${i.params.containerModifierClass}${s}`), i.emitContainerClasses(), i.params.direction = s, i.slides.forEach(n => {
      s === "vertical" ? n.style.width = "" : n.style.height = ""
    }), i.emit("changeDirection"), t && i.update()), i
  }
  changeLanguageDirection(s) {
    const t = this;
    t.rtl && s === "rtl" || !t.rtl && s === "ltr" || (t.rtl = s === "rtl", t.rtlTranslate = t.params.direction === "horizontal" && t.rtl, t.rtl ? (t.el.classList.add(`${t.params.containerModifierClass}rtl`), t.el.dir = "rtl") : (t.el.classList.remove(`${t.params.containerModifierClass}rtl`), t.el.dir = "ltr"), t.update())
  }
  mount(s) {
    const t = this;
    if (t.mounted) return !0;
    let i = s || t.params.el;
    if (typeof i == "string" && (i = document.querySelector(i)), !i) return !1;
    i.swiper = t, i.parentNode && i.parentNode.host && i.parentNode.host.nodeName === t.params.swiperElementNodeName.toUpperCase() && (t.isElement = !0);
    const r = () => `.${(t.params.wrapperClass || "").trim().split(" ").join(".")}`;
    let l = i && i.shadowRoot && i.shadowRoot.querySelector ? i.shadowRoot.querySelector(r()) : _(i, r())[0];
    return !l && t.params.createElements && (l = te("div", t.params.wrapperClass), i.append(l), _(i, `.${t.params.slideClass}`).forEach(o => {
      l.append(o)
    })), Object.assign(t, {
      el: i,
      wrapperEl: l,
      slidesEl: t.isElement && !i.parentNode.host.slideSlots ? i.parentNode.host : l,
      hostEl: t.isElement ? i.parentNode.host : i,
      mounted: !0,
      rtl: i.dir.toLowerCase() === "rtl" || N(i, "direction") === "rtl",
      rtlTranslate: t.params.direction === "horizontal" && (i.dir.toLowerCase() === "rtl" || N(i, "direction") === "rtl"),
      wrongRTL: N(l, "display") === "-webkit-box"
    }), !0
  }
  init(s) {
    const t = this;
    if (t.initialized || t.mount(s) === !1) return t;
    t.emit("beforeInit"), t.params.breakpoints && t.setBreakpoint(), t.addClasses(), t.updateSize(), t.updateSlides(), t.params.watchOverflow && t.checkOverflow(), t.params.grabCursor && t.enabled && t.setGrabCursor(), t.params.loop && t.virtual && t.params.virtual.enabled ? t.slideTo(t.params.initialSlide + t.virtual.slidesBefore, 0, t.params.runCallbacksOnInit, !1, !0) : t.slideTo(t.params.initialSlide, 0, t.params.runCallbacksOnInit, !1, !0), t.params.loop && t.loopCreate(void 0, !0), t.attachEvents();
    const r = [...t.el.querySelectorAll('[loading="lazy"]')];
    return t.isElement && r.push(...t.hostEl.querySelectorAll('[loading="lazy"]')), r.forEach(n => {
      n.complete ? W(t, n) : n.addEventListener("load", l => {
        W(t, l.target)
      })
    }), se(t), t.initialized = !0, se(t), t.emit("init"), t.emit("afterInit"), t
  }
  destroy(s = !0, t = !0) {
    const i = this,
      {
        params: r,
        el: n,
        wrapperEl: l,
        slides: o
      } = i;
    return typeof i.params > "u" || i.destroyed || (i.emit("beforeDestroy"), i.initialized = !1, i.detachEvents(), r.loop && i.loopDestroy(), t && (i.removeClasses(), n && typeof n != "string" && n.removeAttribute("style"), l && l.removeAttribute("style"), o && o.length && o.forEach(a => {
      a.classList.remove(r.slideVisibleClass, r.slideFullyVisibleClass, r.slideActiveClass, r.slideNextClass, r.slidePrevClass), a.removeAttribute("style"), a.removeAttribute("data-swiper-slide-index")
    })), i.emit("destroy"), Object.keys(i.eventsListeners).forEach(a => {
      i.off(a)
    }), s !== !1 && (i.el && typeof i.el != "string" && (i.el.swiper = null), Ee(i)), i.destroyed = !0), null
  }
  static extendDefaults(s) {
    G(ee, s)
  }
  static get extendedDefaults() {
    return ee
  }
  static get defaults() {
    return ue
  }
  static installModule(s) {
    D.prototype.__modules__ || (D.prototype.__modules__ = []);
    const t = D.prototype.__modules__;
    typeof s == "function" && t.indexOf(s) < 0 && t.push(s)
  }
  static use(s) {
    return Array.isArray(s) ? (s.forEach(t => D.installModule(t)), D) : (D.installModule(s), D)
  }
}
Object.keys(Z).forEach(e => {
  Object.keys(Z[e]).forEach(s => {
    D.prototype[s] = Z[e][s]
  })
});
D.use([Ve, _e]);

function Ht({
  swiper: e,
  extendParams: s,
  on: t
}) {
  s({
    parallax: {
      enabled: !1
    }
  });
  const i = "[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]",
    r = (o, a) => {
      const {
        rtl: d
      } = e, p = d ? -1 : 1, c = o.getAttribute("data-swiper-parallax") || "0";
      let u = o.getAttribute("data-swiper-parallax-x"),
        f = o.getAttribute("data-swiper-parallax-y");
      const m = o.getAttribute("data-swiper-parallax-scale"),
        h = o.getAttribute("data-swiper-parallax-opacity"),
        b = o.getAttribute("data-swiper-parallax-rotate");
      if (u || f ? (u = u || "0", f = f || "0") : e.isHorizontal() ? (u = c, f = "0") : (f = c, u = "0"), u.indexOf("%") >= 0 ? u = `${parseInt(u, 10) * a * p}%` : u = `${u * a * p}px`, f.indexOf("%") >= 0 ? f = `${parseInt(f, 10) * a}%` : f = `${f * a}px`, typeof h < "u" && h !== null) {
        const g = h - (h - 1) * (1 - Math.abs(a));
        o.style.opacity = g
      }
      let S = `translate3d(${u}, ${f}, 0px)`;
      if (typeof m < "u" && m !== null) {
        const g = m - (m - 1) * (1 - Math.abs(a));
        S += ` scale(${g})`
      }
      if (b && typeof b < "u" && b !== null) {
        const g = b * a * -1;
        S += ` rotate(${g}deg)`
      }
      o.style.transform = S
    },
    n = () => {
      const {
        el: o,
        slides: a,
        progress: d,
        snapGrid: p,
        isElement: c
      } = e, u = _(o, i);
      e.isElement && u.push(..._(e.hostEl, i)), u.forEach(f => {
        r(f, d)
      }), a.forEach((f, m) => {
        let h = f.progress;
        e.params.slidesPerGroup > 1 && e.params.slidesPerView !== "auto" && (h += Math.ceil(m / 2) - d * (p.length - 1)), h = Math.min(Math.max(h, -1), 1), f.querySelectorAll(`${i}, [data-swiper-parallax-rotate]`).forEach(b => {
          r(b, h)
        })
      })
    },
    l = (o = e.params.speed) => {
      const {
        el: a,
        hostEl: d
      } = e, p = [...a.querySelectorAll(i)];
      e.isElement && p.push(...d.querySelectorAll(i)), p.forEach(c => {
        let u = parseInt(c.getAttribute("data-swiper-parallax-duration"), 10) || o;
        o === 0 && (u = 0), c.style.transitionDuration = `${u}ms`
      })
    };
  t("beforeInit", () => {
    e.params.parallax.enabled && (e.params.watchSlidesProgress = !0, e.originalParams.watchSlidesProgress = !0)
  }), t("init", () => {
    e.params.parallax.enabled && n()
  }), t("setTranslate", () => {
    e.params.parallax.enabled && n()
  }), t("setTransition", (o, a) => {
    e.params.parallax.enabled && l(a)
  })
}

function Rt(e) {
  const s = e.querySelector(".swiper");
  let t = !1,
    i = !1,
    r;
  const n = u => {
    u.classList.add("fashion-slider-no-transition"), i = !0, cancelAnimationFrame(r), r = requestAnimationFrame(() => {
      u.classList.remove("fashion-slider-no-transition"), i = !1, t = !1
    })
  };
  let l;
  const o = () => {
      t || l.slideNext()
    },
    a = () => {
      t || l.slidePrev()
    },
    d = u => {
      u.el.querySelector(".fashion-slider-button-next").addEventListener("click", o), u.el.querySelector(".fashion-slider-button-prev").addEventListener("click", a)
    },
    p = u => {
      u.el.querySelector(".fashion-slider-button-next").removeEventListener("click", o), u.el.querySelector(".fashion-slider-button-prev").removeEventListener("click", a)
    };
  let c;
  return l = new D(s, {
    direction: "horizontal",
    modules: [Ht],
    speed: 1300,
    allowTouchMove: !1,
    parallax: !0,
    on: {
      loopFix() {
        c = !1
      },
      transitionStart(u) {
        if (u.params.loop) {
          if (c) return;
          c || (c = !0)
        }
        const {
          slides: m,
          previousIndex: h,
          activeIndex: b,
          el: S
        } = u;
        i || (t = !0);
        const g = m[b],
          v = m[h],
          E = v.querySelector(".fashion-slider-scale"),
          w = v.querySelector("img"),
          I = g.querySelector("img"),
          M = b - h,
          y = g.getAttribute("data-slide-bg-color");
        S.style["background-color"] = y, E.style.transform = "scale(0.6)", w.style.transitionDuration = "1000ms", w.style.transform = "scale(1.2)";
        const L = v.querySelector(".fashion-slider-title-text");
        L.style.transition = "1000ms", L.style.color = "rgba(255,255,255,0)";
        const x = T => {
          T.target === w && (w.removeEventListener("transitionend", x), I.style.transitionDuration = "1300ms", I.style.transform = "translate3d(0, 0, 0) scale(1.2)", w.style.transitionDuration = "1300ms", w.style.transform = `translate3d(${60 * M * (u.isHorizontal() ? 1 : 0)}%, ${60 * M * (u.isHorizontal() ? 0 : 1)}%, 0)  scale(1.2)`)
        };
        w.addEventListener("transitionend", x)
      },
      transitionEnd(u) {
        const {
          slides: f,
          activeIndex: m,
          el: h
        } = u, b = f[m], S = b.querySelector("img"), g = u.params.loop;
        b.querySelector(".fashion-slider-scale").style.transform = "scale(1)", S.style.transitionDuration = "1000ms", S.style.transform = "scale(1)";
        const v = b.querySelector(".fashion-slider-title-text");
        v.style.transition = "1000ms", v.style.color = "rgba(255,255,255,1)";
        const E = w => {
          w.target === S && (S.removeEventListener("transitionend", E), t = !1)
        };
        S.addEventListener("transitionend", E), g || (m === 0 ? h.querySelector(".fashion-slider-button-prev").classList.add("fashion-slider-button-disabled") : h.querySelector(".fashion-slider-button-prev").classList.remove("fashion-slider-button-disabled"), m === f.length - 1 ? h.querySelector(".fashion-slider-button-next").classList.add("fashion-slider-button-disabled") : h.querySelector(".fashion-slider-button-next").classList.remove("fashion-slider-button-disabled"))
      },
      beforeInit(u) {
        const {
          el: f
        } = u;
        n(f)
      },
      init(u) {
        const {
          slides: f,
          activeIndex: m,
          el: h
        } = u, b = f[m].getAttribute("data-slide-bg-color");
        h.style["background-color"] = b, u.emit("transitionEnd"), d(u)
      },
      resize(u) {
        n(u.el)
      },
      destroy(u) {
        p(u)
      }
    }
  }), l
}
const qt = document.querySelector(".fashion-slider");
Rt(qt);